(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[363],{

/***/ 17494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* reexport */ Checkbox; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
;// CONCATENATED MODULE: ./src/components/Checkbox/checkbox.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 25,
  height: 25,
  rx: 4.5,
  fill: "none",
  stroke: "#C6C6C6"
});

function SvgCheckbox({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var Checkbox_checkbox = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iNC41IiBmaWxsPSJub25lIiBzdHJva2U9IiNDNkM2QzYiLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/components/Checkbox/checkbox-checked.svg
function checkbox_checked_extends() { checkbox_checked_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return checkbox_checked_extends.apply(this, arguments); }



var checkbox_checked_ref = /*#__PURE__*/react.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 25,
  height: 25,
  rx: 4.5,
  fill: "none",
  stroke: "#860935"
});

var _ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M19.6674 8.35674L19.2632 7.95305C18.8195 7.50844 18.0926 7.50844 17.6475 7.95305L10.7859 14.8157L8.35105 12.3818C7.90738 11.9377 7.17999 11.9377 6.73632 12.3823L6.33263 12.7855C5.88896 13.2296 5.88896 13.9565 6.33263 14.4007L9.97613 18.048C10.4203 18.4916 11.1472 18.4916 11.5913 18.048L19.6674 9.97194C20.1106 9.52779 20.1106 8.80088 19.6674 8.35674Z",
  fill: "#860935"
});

function SvgCheckboxChecked({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", checkbox_checked_extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, checkbox_checked_ref, _ref2);
}

/* harmony default export */ var checkbox_checked = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjI1IiBoZWlnaHQ9IjI1IiByeD0iNC41IiBmaWxsPSJub25lIiBzdHJva2U9IiM4NjA5MzUiLz4KICA8cGF0aAogICAgZD0iTTE5LjY2NzQgOC4zNTY3NEwxOS4yNjMyIDcuOTUzMDVDMTguODE5NSA3LjUwODQ0IDE4LjA5MjYgNy41MDg0NCAxNy42NDc1IDcuOTUzMDVMMTAuNzg1OSAxNC44MTU3TDguMzUxMDUgMTIuMzgxOEM3LjkwNzM4IDExLjkzNzcgNy4xNzk5OSAxMS45Mzc3IDYuNzM2MzIgMTIuMzgyM0w2LjMzMjYzIDEyLjc4NTVDNS44ODg5NiAxMy4yMjk2IDUuODg4OTYgMTMuOTU2NSA2LjMzMjYzIDE0LjQwMDdMOS45NzYxMyAxOC4wNDhDMTAuNDIwMyAxOC40OTE2IDExLjE0NzIgMTguNDkxNiAxMS41OTEzIDE4LjA0OEwxOS42Njc0IDkuOTcxOTRDMjAuMTEwNiA5LjUyNzc5IDIwLjExMDYgOC44MDA4OCAxOS42Njc0IDguMzU2NzRaIgogICAgZmlsbD0iIzg2MDkzNSIKICAvPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.tsx







const Checkbox = ({
  id,
  checked,
  onChange,
  label
}) => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Component, {
    children: [checked ? /*#__PURE__*/(0,jsx_runtime.jsx)(SvgCheckboxChecked, {}) : /*#__PURE__*/(0,jsx_runtime.jsx)(SvgCheckbox, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, {
      id: id,
      checked: checked,
      type: "checkbox",
      onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked)
    }), label ? /*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
      dangerouslySetInnerHTML: {
        __html: label
      }
    }) : null]
  });
};
const Component = styled_components_browser_esm["default"].label.withConfig({
  displayName: "Checkbox__Component",
  componentId: "sc-113v4uh-0"
})(["position:relative;cursor:pointer;display:flex;align-items:center;"]);
const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "Checkbox__Input",
  componentId: "sc-113v4uh-1"
})(["cursor:inherit;position:absolute;opacity:0;width:100%;height:100%;top:0;left:0;margin:0;padding:0;z-index:1;"]);
const Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Checkbox__Label",
  componentId: "sc-113v4uh-2"
})(["margin-left:10px;font-size:12px;line-height:16px;position:relative;z-index:2;a{color:", ";text-decoration:underline;&:hover{text-decoration:none;}}"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/components/Checkbox/index.ts


/***/ }),

/***/ 53718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _alias_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@tager/web-components/dist/web-components.esm.js
var web_components_esm = __webpack_require__(63394);
// EXTERNAL MODULE: ./node_modules/@tager/web-core/dist/web-core.esm.js + 6 modules
var web_core_esm = __webpack_require__(61055);
// EXTERNAL MODULE: ./src/pages/_error.tsx
var _error = __webpack_require__(35635);
// EXTERNAL MODULE: ./src/pages/404.tsx + 2 modules
var _404 = __webpack_require__(34340);
// EXTERNAL MODULE: ./src/components/Layout/index.ts
var Layout = __webpack_require__(41880);
// EXTERNAL MODULE: ./src/utils/common.ts
var common = __webpack_require__(29116);
// EXTERNAL MODULE: ./src/utils/thunks.ts
var thunks = __webpack_require__(26625);
// EXTERNAL MODULE: ./src/store/reducers/pages/product/product.ts + 1 modules
var product_product = __webpack_require__(59381);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/providers/Product/index.tsx


const initContext = {
  price: null,
  discountPrice: null,
  optionData: {
    optionName: null,
    optionValue: null
  }
};
const productContext = /*#__PURE__*/(0,react.createContext)(initContext);
function ProductContextProvider({
  children
}) {
  const {
    0: price,
    1: setPrice
  } = (0,react.useState)(initContext.price);
  const {
    0: discountPrice,
    1: setDiscountPrice
  } = (0,react.useState)(initContext.discountPrice);
  const {
    0: optionData,
    1: setOptionData
  } = (0,react.useState)(initContext.optionData);

  const priceHandler = (price, discount) => {
    if (price && discount && discount !== price) {
      setPrice(price);
      setDiscountPrice(discount);
      return;
    }

    if (price) {
      setPrice(price);
    }
  };

  const optionHandler = (0,react.useCallback)((name, value) => {
    setOptionData({
      optionName: name,
      optionValue: value
    });
  }, []);
  const values = {
    price,
    discountPrice,
    priceHandler,
    optionHandler,
    optionData
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(productContext.Provider, {
    value: values,
    children: children
  });
}
// EXTERNAL MODULE: ./src/store/store.ts + 3 modules
var store = __webpack_require__(11402);
// EXTERNAL MODULE: ./src/components/BreadCrumb/index.ts + 2 modules
var BreadCrumb = __webpack_require__(3601);
// EXTERNAL MODULE: ./src/components/ContentContainer.tsx
var ContentContainer = __webpack_require__(64283);
// EXTERNAL MODULE: ./src/constants/theme.ts
var theme = __webpack_require__(84229);
;// CONCATENATED MODULE: ./src/modules/Product/components/Header/Header.tsx












function Header() {
  var _product$name, _product$subtitle;

  const router = (0,next_router.useRouter)();
  const alias = (0,common/* getAliasString */.Jz)(router.query.alias);
  const {
    data: product
  } = (0,store/* useTypedSelector */.ix)(state => {
    return (0,product_product/* selectProductResource */.jN)(state, alias);
  });
  const breadCrumbList = [];

  if (product && product.breadcrumbs) {
    product.breadcrumbs.map(item => breadCrumbList.push({
      label: item.name,
      url: item.link
    }));
    breadCrumbList.push({
      label: product.name
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb/* default */.Z, {
          breadCrumbs: breadCrumbList
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
          children: (_product$name = product === null || product === void 0 ? void 0 : product.name) !== null && _product$name !== void 0 ? _product$name : ''
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Subcontent, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle, {
            children: (_product$subtitle = product === null || product === void 0 ? void 0 : product.subtitle) !== null && _product$subtitle !== void 0 ? _product$subtitle : ''
          })
        })]
      })
    })
  });
}

/* harmony default export */ var Header_Header = (Header);
const Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Component",
  componentId: "sc-c1qzca-0"
})(["margin-top:5px;"]);
const Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Content",
  componentId: "sc-c1qzca-1"
})([""]);
const Name = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Name",
  componentId: "sc-c1qzca-2"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const Subcontent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Subcontent",
  componentId: "sc-c1qzca-3"
})(["display:flex;justify-content:space-between;align-items:center;"]);
const Subtitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Subtitle",
  componentId: "sc-c1qzca-4"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.gray300 */.O9.gray300);
const Code = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Header__Code",
  componentId: "sc-c1qzca-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.black */.O9.black);
const Index = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Header__Index",
  componentId: "sc-c1qzca-6"
})(["font-style:normal;font-weight:600;font-size:12px;line-height:20px;color:", ";"], theme/* colors.black */.O9.black);
;// CONCATENATED MODULE: ./src/modules/Product/components/Header/index.ts

// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper.js + 8 modules
var swiper = __webpack_require__(69447);
// EXTERNAL MODULE: ./node_modules/swiper/esm/react/swiper-slide.js
var swiper_slide = __webpack_require__(24002);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/core/core-class.js + 66 modules
var core_class = __webpack_require__(30172);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
var navigation = __webpack_require__(95186);
// EXTERNAL MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
var pagination = __webpack_require__(52997);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/index.js + 1 modules
var dist = __webpack_require__(46524);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/styles.css
var styles = __webpack_require__(50781);
// EXTERNAL MODULE: ./node_modules/@tager/web-modules/dist/web-modules.esm.js
var web_modules_esm = __webpack_require__(56640);
// EXTERNAL MODULE: ./node_modules/swiper/swiper-bundle.min.css
var swiper_bundle_min = __webpack_require__(72821);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./node_modules/swiper/components/navigation/navigation.min.css
var navigation_min = __webpack_require__(66539);
// EXTERNAL MODULE: ./node_modules/swiper/components/pagination/pagination.min.css
var pagination_min = __webpack_require__(97735);
// EXTERNAL MODULE: ./src/components/Picture.tsx
var Picture = __webpack_require__(97377);
// EXTERNAL MODULE: ./src/components/Spinner/index.ts + 1 modules
var Spinner = __webpack_require__(66595);
;// CONCATENATED MODULE: ./src/modules/Product/components/Gallery/Gallery.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























core_class/* default.use */.Z.use([navigation/* default */.Z, pagination/* default */.Z]);

function Gallery() {
  var _product$data, _gallery$currentIndex;

  const {
    0: currentIndex,
    1: setCurrentIndex
  } = (0,react.useState)(0);
  const router = (0,next_router.useRouter)();
  const dispatch = (0,es/* useDispatch */.I0)();
  const alias = (0,common/* getAliasString */.Jz)(router.query.alias);
  const product = (0,store/* useTypedSelector */.ix)(state => {
    return (0,product_product/* selectProductResource */.jN)(state, alias);
  });
  const gallery = (_product$data = product.data) === null || _product$data === void 0 ? void 0 : _product$data.gallery;
  const [open, setOpen] = react.useState(false);
  const [index, setIndex] = react.useState(0);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(dist/* default */.ZP, {
      index: index,
      on: {
        view: ({
          index: currentIndex
        }) => setIndex(currentIndex)
      },
      open: open,
      close: () => setOpen(false),
      slides: gallery === null || gallery === void 0 ? void 0 : gallery.map(item => {
        var _item$image;

        return {
          src: ((_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.preview.url_2x) || ''
        };
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery_Component, {
      children: product.status === web_core_esm.FETCH_STATUSES.LOADING ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : product.status === web_core_esm.FETCH_STATUSES.SUCCESS ? gallery && !!gallery.length && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [((_gallery$currentIndex = gallery[currentIndex]) === null || _gallery$currentIndex === void 0 ? void 0 : _gallery$currentIndex.text) && /*#__PURE__*/(0,jsx_runtime.jsx)(Description, {
          children: gallery[currentIndex].text
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
          pagination: {
            dynamicBullets: true
          },
          onSlideChange: e => {
            setCurrentIndex(e.realIndex);
            dispatch((0,product_product/* activeIdAdded */.Yb)(e.realIndex));
          },
          onAfterInit: e => {
            dispatch((0,product_product/* activeIdAdded */.Yb)(e.realIndex));
          },
          children: gallery.map((item, index) => {
            var _item$image2;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
              onClick: () => {
                setOpen(true);
                setIndex(index);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledPicture, _objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureProps */.VM)((_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.preview)))
            }, index);
          })
        })]
      }) : null
    })]
  });
}

/* harmony default export */ var Gallery_Gallery = (Gallery);
const Gallery_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Gallery__Component",
  componentId: "sc-mr3oj5-0"
})(["position:relative;min-height:200px;.swiper-container{padding-bottom:10px;height:100%;inset:0;}.swiper-pagination{bottom:0;}"]);
const StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "Gallery__StyledPicture",
  componentId: "sc-mr3oj5-1"
})(["padding:15px 10px;height:200px;width:100%;picture,img{height:100%;object-fit:contain;object-position:left;}"]);
const Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Gallery__Description",
  componentId: "sc-mr3oj5-2"
})(["margin-top:10px;font-size:14px;line-height:18px;width:100%;background:#e9e9e9;text-align:center;padding:5px 10px;min-height:28px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Gallery/index.ts

// EXTERNAL MODULE: ./node_modules/use-intl/dist/production/index.js
var production = __webpack_require__(1617);
// EXTERNAL MODULE: ./src/assets/svg/arrow_question.svg
var arrow_question = __webpack_require__(46293);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/MultiPrice/MultiPriceView.tsx








function MultiPriceView({
  data,
  isOptionsOpen,
  currentIndex,
  setIndex,
  setOpen
}) {
  var _data$options, _data$options$current;

  const selectRef = (0,react.useRef)(null);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MultiPriceView_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Label, {
        children: data === null || data === void 0 ? void 0 : data.label
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SelectWrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledArrow, {
          isopen: isOptionsOpen,
          className: "product-multiprice-select-arrow"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select, {
          ref: selectRef,
          className: "product-multiprice-select",
          onFocus: () => {
            setOpen(pre => !pre);
          },
          onBlur: e => {
            e.target.click();
            setOpen(pre => false);
          },
          onChange: e => {
            setOpen(pre => !pre);

            if (e.target.selectedIndex !== currentIndex) {
              setIndex(e.target.selectedIndex);
            }
          },
          children: ((_data$options = data === null || data === void 0 ? void 0 : data.options) !== null && _data$options !== void 0 ? _data$options : []).map((option, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
            selected: index === currentIndex,
            isSelected: index === currentIndex,
            children: option.name
          }, index))
        })]
      }), (data === null || data === void 0 ? void 0 : data.options) && /*#__PURE__*/(0,jsx_runtime.jsx)(MultiPriceView_Description, {
        children: (_data$options$current = data.options[currentIndex]) === null || _data$options$current === void 0 ? void 0 : _data$options$current.description
      })]
    })
  });
}

/* harmony default export */ var MultiPrice_MultiPriceView = (MultiPriceView);
const MultiPriceView_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiPriceView__Component",
  componentId: "sc-16fwjuz-0"
})([""]);
const Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiPriceView__Label",
  componentId: "sc-16fwjuz-1"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"]);
const SelectWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiPriceView__SelectWrapper",
  componentId: "sc-16fwjuz-2"
})(["margin-top:7px;min-height:34px;max-width:480px;overflow:hidden;border:1px solid ", ";border-radius:5px;position:relative;"], theme/* colors.gray70 */.O9.gray70);
const Select = styled_components_browser_esm["default"].select.withConfig({
  displayName: "MultiPriceView__Select",
  componentId: "sc-16fwjuz-3"
})(["position:absolute;padding-left:15px;height:100%;width:100%;cursor:pointer;outline:none;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;-ms-word-break:normal;word-break:normal;background:transparent;z-index:10;"]);
const Option = styled_components_browser_esm["default"].option.withConfig({
  displayName: "MultiPriceView__Option",
  componentId: "sc-16fwjuz-4"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;", ""], ({
  isSelected
}) => isSelected ? (0,styled_components_browser_esm.css)(["color:", ";font-weight:600;"], theme/* colors.primary */.O9.primary) : (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.black */.O9.black));
const StyledArrow = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "MultiPriceView__StyledArrow",
  componentId: "sc-16fwjuz-5"
})(["cursor:pointer;position:absolute;top:50%;right:15px;transform:translateY(-50%) ", ";path{fill:rgba(0,0,0,1);}z-index:1;"], ({
  isopen
}) => isopen ? ' rotate(180deg)' : ' rotate(0)');
const MultiPriceView_Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiPriceView__Description",
  componentId: "sc-16fwjuz-6"
})(["margin-top:5px;font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.grayDark */.O9.grayDark);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/MultiPrice/MultiPrice.tsx






function MultiPrice({
  product
}) {
  const {
    0: isOptionsOpen,
    1: setOpen
  } = (0,react.useState)(false);
  const {
    0: currentIndex,
    1: setIndex
  } = (0,react.useState)(0);
  const {
    priceHandler,
    optionHandler
  } = (0,react.useContext)(productContext);
  const valuesData = (0,react.useMemo)(() => {
    var _product$multiplePric;

    if (!(product !== null && product !== void 0 && product.multiplePricesEnabled) || !(product !== null && product !== void 0 && product.multiplePricesLabel) || !(product !== null && product !== void 0 && (_product$multiplePric = product.multiplePricesValues) !== null && _product$multiplePric !== void 0 && _product$multiplePric.length)) {
      return null;
    }

    return {
      label: product.multiplePricesLabel,
      options: product.multiplePricesValues,
      enabled: product.multiplePricesEnabled
    };
  }, [product]);
  (0,react.useEffect)(() => {
    if (valuesData !== null && valuesData !== void 0 && valuesData.enabled && valuesData !== null && valuesData !== void 0 && valuesData.label) {
      optionHandler === null || optionHandler === void 0 ? void 0 : optionHandler(valuesData.label, valuesData.options[currentIndex].name);
      priceHandler === null || priceHandler === void 0 ? void 0 : priceHandler(valuesData.options[currentIndex].price, valuesData.options[currentIndex].discountPrice);
    } else {
      priceHandler === null || priceHandler === void 0 ? void 0 : priceHandler(product === null || product === void 0 ? void 0 : product.price, product === null || product === void 0 ? void 0 : product.discountPrice);
    }
  }, [currentIndex, product === null || product === void 0 ? void 0 : product.discountPrice, product === null || product === void 0 ? void 0 : product.price, valuesData === null || valuesData === void 0 ? void 0 : valuesData.enabled, valuesData === null || valuesData === void 0 ? void 0 : valuesData.label, valuesData === null || valuesData === void 0 ? void 0 : valuesData.options]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MultiPrice_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: valuesData ? /*#__PURE__*/(0,jsx_runtime.jsx)(MultiPrice_MultiPriceView, {
        data: valuesData,
        setOpen: setOpen,
        setIndex: setIndex,
        isOptionsOpen: isOptionsOpen,
        currentIndex: currentIndex
      }) : null
    })
  });
}

/* harmony default export */ var MultiPrice_MultiPrice = (MultiPrice);
const MultiPrice_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiPrice__Component",
  componentId: "sc-3tg3qw-0"
})([""]);
const Wrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "MultiPrice__Wrapper",
  componentId: "sc-3tg3qw-1"
})(["margin-top:11px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/MultiPrice/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/delivery.svg
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var _ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.9999 20.0002C27.9999 22.2091 26.2098 24.0001 23.9999 24.0001C21.7899 24.0001 19.9999 22.2091 19.9999 20.0002H11.9999C11.9999 22.2091 10.2099 24.0001 7.99988 24.0001C5.78991 24.0001 3.99984 22.2091 3.99984 20.0002C1.79088 20.0002 0 18.2092 0 16.0003V13.9981L3.73033 8.00005C4.76073 5.79128 7.38671 4.00029 9.59578 4.00029H13.9999V0H32V12.0001V13.9998V16.0003C32 18.2092 30.209 20.0002 27.9999 20.0002ZM23.9999 22C25.1025 22 26 21.1037 26 20.0002C26 18.8965 25.1025 18.0001 23.9999 18.0001C22.8974 18.0001 21.9999 18.8965 21.9999 20.0002C21.9999 21.1037 22.8974 22 23.9999 22ZM7.99988 22C9.10252 22 9.99995 21.1037 9.99995 20.0002C9.99995 18.8965 9.10252 18.0001 7.99988 18.0001C6.89735 18.0001 5.99991 18.8965 5.99991 20.0002C5.99991 21.1037 6.89735 22 7.99988 22ZM29.9999 2.00005H16V4.00029V12.0001H29.9999V2.00005ZM29.9999 13.9998H13.9999V12.0001V5.99997H9.59578C8.16889 5.99997 6.23739 7.35539 5.54295 8.84596L5.49213 8.95325L5.42874 9.05674L3.5986 12.0001L1.99987 13.9998V16.0003C1.99987 17.1038 2.8973 18.0001 3.99984 18.0001H4.55451C5.24688 16.8087 6.52232 16.0003 7.99988 16.0003C9.47754 16.0003 10.7529 16.8087 11.4454 18.0001H20.5545C21.247 16.8087 22.5223 16.0003 23.9999 16.0003C25.4775 16.0003 26.753 16.8087 27.4454 18.0001H27.9999C29.1026 18.0001 29.9999 17.1038 29.9999 16.0003V13.9998Z",
  fill: "black"
});

function SvgDelivery({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

/* harmony default export */ var delivery = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAzMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNy45OTk5IDIwLjAwMDJDMjcuOTk5OSAyMi4yMDkxIDI2LjIwOTggMjQuMDAwMSAyMy45OTk5IDI0LjAwMDFDMjEuNzg5OSAyNC4wMDAxIDE5Ljk5OTkgMjIuMjA5MSAxOS45OTk5IDIwLjAwMDJIMTEuOTk5OUMxMS45OTk5IDIyLjIwOTEgMTAuMjA5OSAyNC4wMDAxIDcuOTk5ODggMjQuMDAwMUM1Ljc4OTkxIDI0LjAwMDEgMy45OTk4NCAyMi4yMDkxIDMuOTk5ODQgMjAuMDAwMkMxLjc5MDg4IDIwLjAwMDIgMCAxOC4yMDkyIDAgMTYuMDAwM1YxMy45OTgxTDMuNzMwMzMgOC4wMDAwNUM0Ljc2MDczIDUuNzkxMjggNy4zODY3MSA0LjAwMDI5IDkuNTk1NzggNC4wMDAyOUgxMy45OTk5VjBIMzJWMTIuMDAwMVYxMy45OTk4VjE2LjAwMDNDMzIgMTguMjA5MiAzMC4yMDkgMjAuMDAwMiAyNy45OTk5IDIwLjAwMDJaTTIzLjk5OTkgMjJDMjUuMTAyNSAyMiAyNiAyMS4xMDM3IDI2IDIwLjAwMDJDMjYgMTguODk2NSAyNS4xMDI1IDE4LjAwMDEgMjMuOTk5OSAxOC4wMDAxQzIyLjg5NzQgMTguMDAwMSAyMS45OTk5IDE4Ljg5NjUgMjEuOTk5OSAyMC4wMDAyQzIxLjk5OTkgMjEuMTAzNyAyMi44OTc0IDIyIDIzLjk5OTkgMjJaTTcuOTk5ODggMjJDOS4xMDI1MiAyMiA5Ljk5OTk1IDIxLjEwMzcgOS45OTk5NSAyMC4wMDAyQzkuOTk5OTUgMTguODk2NSA5LjEwMjUyIDE4LjAwMDEgNy45OTk4OCAxOC4wMDAxQzYuODk3MzUgMTguMDAwMSA1Ljk5OTkxIDE4Ljg5NjUgNS45OTk5MSAyMC4wMDAyQzUuOTk5OTEgMjEuMTAzNyA2Ljg5NzM1IDIyIDcuOTk5ODggMjJaTTI5Ljk5OTkgMi4wMDAwNUgxNlY0LjAwMDI5VjEyLjAwMDFIMjkuOTk5OVYyLjAwMDA1Wk0yOS45OTk5IDEzLjk5OThIMTMuOTk5OVYxMi4wMDAxVjUuOTk5OTdIOS41OTU3OEM4LjE2ODg5IDUuOTk5OTcgNi4yMzczOSA3LjM1NTM5IDUuNTQyOTUgOC44NDU5Nkw1LjQ5MjEzIDguOTUzMjVMNS40Mjg3NCA5LjA1Njc0TDMuNTk4NiAxMi4wMDAxTDEuOTk5ODcgMTMuOTk5OFYxNi4wMDAzQzEuOTk5ODcgMTcuMTAzOCAyLjg5NzMgMTguMDAwMSAzLjk5OTg0IDE4LjAwMDFINC41NTQ1MUM1LjI0Njg4IDE2LjgwODcgNi41MjIzMiAxNi4wMDAzIDcuOTk5ODggMTYuMDAwM0M5LjQ3NzU0IDE2LjAwMDMgMTAuNzUyOSAxNi44MDg3IDExLjQ0NTQgMTguMDAwMUgyMC41NTQ1QzIxLjI0NyAxNi44MDg3IDIyLjUyMjMgMTYuMDAwMyAyMy45OTk5IDE2LjAwMDNDMjUuNDc3NSAxNi4wMDAzIDI2Ljc1MyAxNi44MDg3IDI3LjQ0NTQgMTguMDAwMUgyNy45OTk5QzI5LjEwMjYgMTguMDAwMSAyOS45OTk5IDE3LjEwMzggMjkuOTk5OSAxNi4wMDAzVjEzLjk5OThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/wallet.svg
function wallet_extends() { wallet_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return wallet_extends.apply(this, arguments); }



var wallet_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.0001 0H28.0001C30.2091 0 32.0001 1.79098 32.0001 3.99971V21.9998C32.0001 24.209 30.2091 25.9997 28.0001 25.9997H24.0001H4.00019C1.79112 25.9997 0 24.209 0 21.9998V3.99971C0 1.79098 1.79112 0 4.00019 0H24.0001ZM30 7.99982V3.99971C30 2.89716 29.1027 1.99987 28.0001 1.99987H27.4456C27.7891 2.59066 28.0001 3.26752 28.0001 3.99971V7.99982H30ZM20 12.9998C20 14.6541 21.3459 15.9999 23.0001 15.9999H30V9.9999H23.0001C21.3459 9.9999 20 11.3458 20 12.9998ZM2.00008 21.9998C2.00008 23.1024 2.89754 23.9997 4.00019 23.9997H24.0001C25.1027 23.9997 26.0001 23.1024 26.0001 21.9998V17.9999H23.0001C20.2382 17.9999 18.0001 15.7616 18.0001 12.9998C18.0001 10.238 20.2382 7.99982 23.0001 7.99982H26.0001V3.99971C26.0001 2.89716 25.1027 1.99987 24.0001 1.99987H4.00019C2.89754 1.99987 2.00008 2.89716 2.00008 3.99971V21.9998ZM27.4456 23.9997H28.0001C29.1027 23.9997 30 23.1024 30 21.9998V17.9999H28.0001V21.9998C28.0001 22.7322 27.7891 23.4091 27.4456 23.9997ZM22 12.9998C22 12.4469 22.4473 11.9999 23.0001 11.9999C23.5529 11.9999 24.0001 12.4469 24.0001 12.9998C24.0001 13.5527 23.5529 13.9998 23.0001 13.9998C22.4473 13.9998 22 13.5527 22 12.9998Z",
  fill: "black"
});

function SvgWallet({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", wallet_extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, wallet_ref);
}

/* harmony default export */ var wallet = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzMiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNC4wMDAxIDBIMjguMDAwMUMzMC4yMDkxIDAgMzIuMDAwMSAxLjc5MDk4IDMyLjAwMDEgMy45OTk3MVYyMS45OTk4QzMyLjAwMDEgMjQuMjA5IDMwLjIwOTEgMjUuOTk5NyAyOC4wMDAxIDI1Ljk5OTdIMjQuMDAwMUg0LjAwMDE5QzEuNzkxMTIgMjUuOTk5NyAwIDI0LjIwOSAwIDIxLjk5OThWMy45OTk3MUMwIDEuNzkwOTggMS43OTExMiAwIDQuMDAwMTkgMEgyNC4wMDAxWk0zMCA3Ljk5OTgyVjMuOTk5NzFDMzAgMi44OTcxNiAyOS4xMDI3IDEuOTk5ODcgMjguMDAwMSAxLjk5OTg3SDI3LjQ0NTZDMjcuNzg5MSAyLjU5MDY2IDI4LjAwMDEgMy4yNjc1MiAyOC4wMDAxIDMuOTk5NzFWNy45OTk4MkgzMFpNMjAgMTIuOTk5OEMyMCAxNC42NTQxIDIxLjM0NTkgMTUuOTk5OSAyMy4wMDAxIDE1Ljk5OTlIMzBWOS45OTk5SDIzLjAwMDFDMjEuMzQ1OSA5Ljk5OTkgMjAgMTEuMzQ1OCAyMCAxMi45OTk4Wk0yLjAwMDA4IDIxLjk5OThDMi4wMDAwOCAyMy4xMDI0IDIuODk3NTQgMjMuOTk5NyA0LjAwMDE5IDIzLjk5OTdIMjQuMDAwMUMyNS4xMDI3IDIzLjk5OTcgMjYuMDAwMSAyMy4xMDI0IDI2LjAwMDEgMjEuOTk5OFYxNy45OTk5SDIzLjAwMDFDMjAuMjM4MiAxNy45OTk5IDE4LjAwMDEgMTUuNzYxNiAxOC4wMDAxIDEyLjk5OThDMTguMDAwMSAxMC4yMzggMjAuMjM4MiA3Ljk5OTgyIDIzLjAwMDEgNy45OTk4MkgyNi4wMDAxVjMuOTk5NzFDMjYuMDAwMSAyLjg5NzE2IDI1LjEwMjcgMS45OTk4NyAyNC4wMDAxIDEuOTk5ODdINC4wMDAxOUMyLjg5NzU0IDEuOTk5ODcgMi4wMDAwOCAyLjg5NzE2IDIuMDAwMDggMy45OTk3MVYyMS45OTk4Wk0yNy40NDU2IDIzLjk5OTdIMjguMDAwMUMyOS4xMDI3IDIzLjk5OTcgMzAgMjMuMTAyNCAzMCAyMS45OTk4VjE3Ljk5OTlIMjguMDAwMVYyMS45OTk4QzI4LjAwMDEgMjIuNzMyMiAyNy43ODkxIDIzLjQwOTEgMjcuNDQ1NiAyMy45OTk3Wk0yMiAxMi45OTk4QzIyIDEyLjQ0NjkgMjIuNDQ3MyAxMS45OTk5IDIzLjAwMDEgMTEuOTk5OUMyMy41NTI5IDExLjk5OTkgMjQuMDAwMSAxMi40NDY5IDI0LjAwMDEgMTIuOTk5OEMyNC4wMDAxIDEzLjU1MjcgMjMuNTUyOSAxMy45OTk4IDIzLjAwMDEgMTMuOTk5OEMyMi40NDczIDEzLjk5OTggMjIgMTMuNTUyNyAyMiAxMi45OTk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/size.svg
function size_extends() { size_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return size_extends.apply(this, arguments); }



var size_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.8938 0.573801C15.9067 0.598769 15.9193 0.62324 15.9295 0.650156C15.9712 0.76085 16 0.876655 16 0.999471V4.9996C16 5.55191 15.5522 5.99943 15 5.99943C14.4477 5.99943 14 5.55191 14 4.9996V3.41369L10.707 6.70643C10.5116 6.90184 10.2559 6.99946 9.99997 6.99946C9.74407 6.99946 9.4883 6.90184 9.29296 6.70643C8.90224 6.31596 8.90224 5.68308 9.29296 5.29262L12.586 1.99931H11C10.4478 1.99931 9.99997 1.55199 9.99997 0.999471C9.99997 0.44678 10.4478 -0.000366211 11 -0.000366211H15C15.0061 -0.000366211 15.0117 0.00125194 15.0172 0.00287402C15.0223 0.00434664 15.0274 0.0058225 15.0329 0.00609374C15.1508 0.00987474 15.2691 0.0278868 15.3828 0.0756528C15.3833 0.0757586 15.3838 0.0760995 15.3842 0.0764467C15.3846 0.0767235 15.3849 0.0770042 15.3853 0.0771728C15.3901 0.0792613 15.3943 0.0821383 15.3984 0.0850047C15.4022 0.0875882 15.4059 0.0901632 15.41 0.0921447C15.5099 0.137061 15.5974 0.198279 15.6752 0.270688C15.6933 0.287446 15.7086 0.305535 15.7242 0.32394C15.7307 0.331556 15.7372 0.339226 15.744 0.346878C15.7998 0.410376 15.8462 0.479175 15.8843 0.555194C15.8875 0.561456 15.8906 0.567644 15.8938 0.573801ZM3.41415 1.99939H4.99994C5.55224 1.99939 6.00005 1.55208 6.00005 0.999557C6.00005 0.446866 5.55224 -0.000279903 4.99994 -0.000279903H1.00001C0.877323 -0.000279903 0.761404 0.028163 0.650843 0.070039C0.622843 0.080616 0.597698 0.093548 0.571785 0.106875L0.555976 0.114974C0.480223 0.153259 0.411443 0.199505 0.34747 0.255422C0.340369 0.261633 0.33327 0.267635 0.326221 0.273594L0.32622 0.273594C0.307242 0.289638 0.288632 0.30537 0.271356 0.324031C0.19927 0.402121 0.138147 0.489122 0.0929463 0.589024C0.0909943 0.593234 0.0883779 0.596984 0.0857504 0.60075C0.0828282 0.604938 0.0798922 0.609146 0.0778413 0.614028L0.0769862 0.615358L0.0761311 0.616688C0.0296571 0.728902 0.0117022 0.845657 0.00735116 0.962792C0.00718604 0.96892 0.00547075 0.974609 0.00374067 0.980348C0.00188741 0.986495 1.71661e-05 0.992698 1.71661e-05 0.999557V4.99968C1.71661e-05 5.55199 0.447828 5.99952 1.00001 5.99952C1.55218 5.99952 2 5.55199 2 4.99968V3.41377L5.29304 6.70651C5.48826 6.90193 5.74415 6.99955 6.00005 6.99955C6.25594 6.99955 6.51172 6.90193 6.70694 6.70651C7.09766 6.31604 7.09766 5.68317 6.70694 5.2927L3.41415 1.99939ZM1.99998 12.5855L5.29302 9.29236C5.6836 8.9017 6.31634 8.9017 6.70692 9.29236C7.09764 9.683 7.09764 10.3159 6.70692 10.7065L3.41413 13.9995H4.99993C5.55222 13.9995 6.00003 14.4468 6.00003 14.9993C6.00003 15.5522 5.55222 15.9993 4.99993 15.9993H0.999989C0.871131 15.9993 0.741133 15.9749 0.617177 15.9233C0.616151 15.9229 0.615353 15.9224 0.614441 15.9216C0.610004 15.9197 0.606208 15.9171 0.602422 15.9145C0.598684 15.9119 0.594957 15.9093 0.590634 15.9074C0.490504 15.8621 0.402838 15.8007 0.324786 15.7283C0.306385 15.7112 0.29072 15.6927 0.274786 15.6739L0.27478 15.6739L0.27477 15.6739C0.268614 15.6667 0.262417 15.6594 0.256006 15.6521C0.200051 15.5884 0.153691 15.5196 0.11571 15.444L0.106852 15.4267C0.0936499 15.401 0.0808908 15.3763 0.070509 15.3488C0.028728 15.2379 0 15.1221 0 14.9993V10.9994C0 10.4467 0.447811 9.99954 0.999989 9.99954C1.55217 9.99954 1.99998 10.4467 1.99998 10.9994V12.5855ZM14 10.9994C14 10.4467 14.4477 9.99954 15 9.99954C15.5522 9.99954 16 10.4467 16 10.9994V14.9993C16 15.0062 15.9981 15.0124 15.9963 15.0186C15.9945 15.0243 15.9928 15.0301 15.9925 15.0364C15.9882 15.1532 15.9702 15.2698 15.9238 15.3824C15.9236 15.383 15.9233 15.3833 15.923 15.3838L15.9228 15.384C15.9225 15.3843 15.9223 15.3846 15.9222 15.385C15.9201 15.3899 15.9172 15.3941 15.9143 15.3983L15.9143 15.3983C15.9118 15.4019 15.9093 15.4055 15.9074 15.4095C15.8622 15.5095 15.8009 15.5969 15.7287 15.6748C15.7122 15.6926 15.6944 15.7077 15.6763 15.7231L15.6763 15.7231L15.6763 15.7231C15.6684 15.7298 15.6605 15.7366 15.6525 15.7436C15.5886 15.7995 15.5197 15.846 15.4438 15.8841L15.4212 15.8956C15.3978 15.9076 15.3747 15.9194 15.3494 15.929C15.2387 15.9705 15.1227 15.9993 15 15.9993H11C10.4478 15.9993 9.99997 15.5522 9.99997 14.9993C9.99997 14.4468 10.4478 13.9995 11 13.9995H12.586L9.29296 10.7065C8.90224 10.3159 8.90224 9.683 9.29296 9.29236C9.68354 8.9017 10.3164 8.9017 10.707 9.29236L14 12.5855V10.9994Z",
  fill: "black"
});

function SvgSize({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", size_extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, size_ref);
}

/* harmony default export */ var size = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/components/TextWithIcon/TextWithIcon.tsx








var Icon;

(function (Icon) {
  Icon["DELIVERY"] = "delivery";
  Icon["WALLET"] = "wallet";
  Icon["SIZE"] = "size";
})(Icon || (Icon = {}));

function getIconElement(icon) {
  return icon === Icon.DELIVERY ? StyledDelivery : icon === Icon.WALLET ? StyledWallet : icon === Icon.SIZE ? StyledDSize : null;
}

function TextWithIcon({
  icon,
  text,
  textButton,
  note,
  hasColor,
  fontWeight,
  marginTop,
  onClick
}) {
  const IconElement = getIconElement(icon);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TextWithIcon_Component, {
    marginTop: marginTop,
    onClick: onClick,
    children: [IconElement && /*#__PURE__*/(0,jsx_runtime.jsx)(IconElement, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Note, {
        highlighted: !!hasColor,
        weight: fontWeight,
        children: note
      }), text ? textButton ? /*#__PURE__*/(0,jsx_runtime.jsx)(TextButton, {
        children: text
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Text, {
        children: text
      }) : null]
    })]
  });
}

/* harmony default export */ var TextWithIcon_TextWithIcon = (TextWithIcon);
const TextWithIcon_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextWithIcon__Component",
  componentId: "sc-1l4dv8h-0"
})(["", " display:flex;align-items:center;"], ({
  marginTop
}) => marginTop && (0,styled_components_browser_esm.css)(["margin-top:", "px;"], marginTop));
const TextWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextWithIcon__TextWrapper",
  componentId: "sc-1l4dv8h-1"
})([""]);
const Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextWithIcon__Note",
  componentId: "sc-1l4dv8h-2"
})(["font-style:normal;font-size:12px;line-height:24px;", ""], ({
  highlighted,
  weight
}) => highlighted ? (0,styled_components_browser_esm.css)(["font-weight:", ";color:", ";"], weight, theme/* colors.primary */.O9.primary) : (0,styled_components_browser_esm.css)(["font-weight:", ";color:", ";"], weight, theme/* colors.black */.O9.black));
const Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "TextWithIcon__Text",
  componentId: "sc-1l4dv8h-3"
})(["font-style:normal;font-weight:500;font-size:16px;line-height:24px;"]);
const TextButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "TextWithIcon__TextButton",
  componentId: "sc-1l4dv8h-4"
})(["font-style:normal;font-weight:600;font-size:12px;line-height:24px;color:", ";"], theme/* colors.primary */.O9.primary);
const marginRight14 = (0,styled_components_browser_esm.css)(["margin-right:14px;"]);
const marginRight10 = (0,styled_components_browser_esm.css)(["margin-right:14px;"]);
const StyledWallet = (0,styled_components_browser_esm["default"])(SvgDelivery).withConfig({
  displayName: "TextWithIcon__StyledWallet",
  componentId: "sc-1l4dv8h-5"
})(["", ""], marginRight14);
const StyledDelivery = (0,styled_components_browser_esm["default"])(SvgWallet).withConfig({
  displayName: "TextWithIcon__StyledDelivery",
  componentId: "sc-1l4dv8h-6"
})(["", ""], marginRight14);
const StyledDSize = (0,styled_components_browser_esm["default"])(SvgSize).withConfig({
  displayName: "TextWithIcon__StyledDSize",
  componentId: "sc-1l4dv8h-7"
})(["", ""], marginRight10);
;// CONCATENATED MODULE: ./src/components/TextWithIcon/index.ts

// EXTERNAL MODULE: ./src/components/Link.tsx
var Link = __webpack_require__(3570);
;// CONCATENATED MODULE: ./src/product.ts
const BLOG_TISSUE_URL = '/blog/divannye-tkani-plyusy-i-minusy';
// EXTERNAL MODULE: ./src/typings/model.ts
var model = __webpack_require__(77771);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/helpres.ts

function getOrderType(type, t) {
  switch (type) {
    case model/* AvailabilityStatus.AVAILABLE */.p.AVAILABLE:
      return t('orderType.in_stock');

    case model/* AvailabilityStatus.ON_REQUEST */.p.ON_REQUEST:
      return t('orderType.to_order');

    case model/* AvailabilityStatus.PRE_ORDER */.p.PRE_ORDER:
      return t('orderType.pre_order');

    case model/* AvailabilityStatus.OUT_OF_ORDER */.p.OUT_OF_ORDER:
      return t('orderType.out_of_stock');

    default:
      return null;
  }
}
;// CONCATENATED MODULE: ./src/assets/svg/Calculator/calculator.svg
function calculator_extends() { calculator_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return calculator_extends.apply(this, arguments); }



var calculator_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.99996 0H11.9999C13.1045 0 13.9999 0.895204 13.9999 1.99986V13.9998C13.9999 15.1045 13.1045 15.9999 11.9999 15.9999H1.99996C0.89539 15.9999 0 15.1045 0 13.9998V1.99986C0 0.895204 0.89539 0 1.99996 0ZM1.99996 13.9998H11.9999V1.99986H1.99996V13.9998ZM9.99996 5.99997H3.99995C3.44765 5.99997 2.99996 5.55227 2.99996 4.99994C2.99996 4.44761 3.44765 3.99992 3.99995 3.99992H9.99996C10.5523 3.99992 11 4.44761 11 4.99994C11 5.55227 10.5523 5.99997 9.99996 5.99997ZM3.99995 9.99989C4.55235 9.99989 5.00004 9.55219 5.00004 8.99986C5.00004 8.44753 4.55235 8.00003 3.99995 8.00003C3.44765 8.00003 2.99996 8.44753 2.99996 8.99986C2.99996 9.55219 3.44765 9.99989 3.99995 9.99989ZM5.00004 11.9999C5.00004 12.5521 4.55235 12.9998 3.99995 12.9998C3.44765 12.9998 2.99996 12.5521 2.99996 11.9999C2.99996 11.4476 3.44765 10.9999 3.99995 10.9999C4.55235 10.9999 5.00004 11.4476 5.00004 11.9999ZM7 8.00003C6.44773 8.00003 5.99991 8.44753 5.99991 8.99986C5.99991 9.55219 6.44773 9.99989 7 9.99989C7.5523 9.99989 8 9.55219 8 8.99986C8 8.44753 7.5523 8.00003 7 8.00003ZM5.99991 11.9999C5.99991 11.4476 6.44773 10.9999 7 10.9999C7.5523 10.9999 8 11.4476 8 11.9999C8 12.5521 7.5523 12.9998 7 12.9998C6.44773 12.9998 5.99991 12.5521 5.99991 11.9999ZM9.99996 8.00003C9.44768 8.00003 8.99999 8.44753 8.99999 8.99986C8.99999 9.55219 9.44768 9.99989 9.99996 9.99989C10.5523 9.99989 11 9.55219 11 8.99986C11 8.44753 10.5523 8.00003 9.99996 8.00003ZM8.99999 11.9999C8.99999 11.4476 9.44768 10.9999 9.99996 10.9999C10.5523 10.9999 11 11.4476 11 11.9999C11 12.5521 10.5523 12.9998 9.99996 12.9998C9.44768 12.9998 8.99999 12.5521 8.99999 11.9999Z",
  fill: "#860935"
});

function SvgCalculator({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", calculator_extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, calculator_ref);
}

/* harmony default export */ var calculator = ("data:image/svg+xml;base64,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");

// EXTERNAL MODULE: ./src/hooks/index.ts + 3 modules
var hooks = __webpack_require__(88619);
// EXTERNAL MODULE: ./src/modules/Rassrochka/components/Calculator/Clculator.typings.ts
var Clculator_typings = __webpack_require__(44260);
// EXTERNAL MODULE: ./src/modules/Rassrochka/components/Calculator/Calculator.helpers.ts
var Calculator_helpers = __webpack_require__(31346);
// EXTERNAL MODULE: ./src/assets/svg/Modals/close.svg
var Modals_close = __webpack_require__(93245);
// EXTERNAL MODULE: ./src/hooks/useModalsOpen.tsx
var useModalsOpen = __webpack_require__(73637);
// EXTERNAL MODULE: ./src/hooks/useBodyPositionFixed.tsx
var useBodyPositionFixed = __webpack_require__(35535);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/assets/svg/cart.svg
var cart = __webpack_require__(53784);
// EXTERNAL MODULE: ./src/assets/svg/wallet_small.svg
var wallet_small = __webpack_require__(47829);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/CardCalculator/components/CalculatorInput.tsx


const _excluded = ["icon"];

function CalculatorInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CalculatorInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CalculatorInput_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CalculatorInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }









function CalculatorInput(_ref, ref) {
  let {
    icon
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  const CurrentIcon = icon === 'cart' ? cart/* ReactComponent */.r : wallet_small/* ReactComponent */.r;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(IconItem, {
      as: CurrentIcon
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Input, CalculatorInput_objectSpread({
      ref: ref
    }, rest))]
  });
}

/* harmony default export */ var components_CalculatorInput = (/*#__PURE__*/react.forwardRef(CalculatorInput));
const Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorInput__Container",
  componentId: "sc-xln362-0"
})(["position:relative;width:100%;height:35px;"]);
const Input = styled_components_browser_esm["default"].input.withConfig({
  displayName: "CalculatorInput__Input",
  componentId: "sc-xln362-1"
})(["padding-left:40px;width:100%;height:100%;border:1px solid ", ";border-radius:5px;font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"], theme/* colors.gray70 */.O9.gray70);
const IconItem = styled_components_browser_esm["default"].svg.withConfig({
  displayName: "CalculatorInput__IconItem",
  componentId: "sc-xln362-2"
})(["position:absolute;left:15px;top:50%;transform:translateY(-50%);"]);
// EXTERNAL MODULE: ./src/assets/svg/time.svg
var time = __webpack_require__(21574);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/CardCalculator/components/CalculatorSelect.tsx









function CalculatorSelect({
  data,
  setData
}) {
  var _data$currentPeriodIn, _data$currentPeriodIn2;

  const {
    0: currentPeriodIndex,
    1: setIndex
  } = (0,react.useState)(0);
  const {
    0: isOptionsOpen,
    1: setOpen
  } = (0,react.useState)(false);

  const selectHandler = () => {
    setOpen(pre => !pre);
  };

  const clickHandler = index => {
    setIndex(index);
    setData(index);
  };

  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Component, {
    onClick: selectHandler,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTime, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Option, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Label, {
        isSelected: true,
        children: [(_data$currentPeriodIn = (_data$currentPeriodIn2 = data[currentPeriodIndex]) === null || _data$currentPeriodIn2 === void 0 ? void 0 : _data$currentPeriodIn2.period) !== null && _data$currentPeriodIn !== void 0 ? _data$currentPeriodIn : '', " ", t('dimensions.months')]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CalculatorSelect_StyledArrow, {
        isopen: isOptionsOpen
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse, {
      isVisible: isOptionsOpen,
      children: !!data.length && data.map(({
        period
      }, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(CalculatorSelect_Option, {
        onClick: () => clickHandler(index),
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CalculatorSelect_Label, {
          children: [period !== null && period !== void 0 ? period : '', " ", t('dimensions.months')]
        })
      }, index))
    })]
  });
}

/* harmony default export */ var components_CalculatorSelect = (CalculatorSelect);
const CalculatorSelect_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Component",
  componentId: "sc-hi10gr-0"
})(["position:relative;display:flex;align-items:center;flex-direction:column;padding:4px 15px 4px 40px;min-height:34px;cursor:pointer;border:1px solid ", ";border-radius:5px;"], theme/* colors.gray70 */.O9.gray70);
const StyledTime = (0,styled_components_browser_esm["default"])(time/* ReactComponent */.r).withConfig({
  displayName: "CalculatorSelect__StyledTime",
  componentId: "sc-hi10gr-1"
})(["position:absolute;left:15px;top:50%;transform:translateY(-50%);"]);
const CalculatorSelect_Option = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Option",
  componentId: "sc-hi10gr-2"
})(["display:flex;align-items:center;justify-content:space-between;width:100%;flex:1;"]);
const CalculatorSelect_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Label",
  componentId: "sc-hi10gr-3"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;color:", ";&:hover{color:", ";}"], ({
  isSelected
}) => isSelected ? `${theme/* colors.primary */.O9.primary}` : `${theme/* colors.black */.O9.black}`, theme/* colors.primary */.O9.primary);
const CalculatorSelect_StyledArrow = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "CalculatorSelect__StyledArrow",
  componentId: "sc-hi10gr-4"
})(["transform:", ";path{fill:rgba(0,0,0,1);}"], ({
  isopen
}) => isopen ? 'rotate(180deg)' : 'rotate(0)');
const Collapse = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CalculatorSelect__Collapse",
  componentId: "sc-hi10gr-5"
})(["position:absolute;display:", ";width:100%;padding:4px 0 4px 15px;top:calc(100% + 1px);left:0;background-color:white;z-index:3;border:1px solid ", ";border-radius:5px;"], ({
  isVisible
}) => isVisible ? 'block' : 'none', theme/* colors.gray70 */.O9.gray70);
// EXTERNAL MODULE: ./src/assets/svg/Calculator/wallet.svg
var Calculator_wallet = __webpack_require__(65497);
// EXTERNAL MODULE: ./src/assets/svg/Calculator/bank.svg
var bank = __webpack_require__(53497);
// EXTERNAL MODULE: ./src/assets/svg/Calculator/card.svg
var card = __webpack_require__(80305);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/CardCalculator/components/Output.tsx












function Output({
  output
}) {
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Calculator_wallet/* ReactComponent */.r, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Label, {
          children: [t('rassrochka.summary'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Note, {
          children: [(0,common/* normalizePrice */.nQ)(output.price), " ", currency]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(bank/* ReactComponent */.r, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Label, {
          children: [t('rassrochka.overpay'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Note, {
          children: [(0,common/* normalizePrice */.nQ)(output.underpayment), " ", currency]
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Item, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(card/* ReactComponent */.r, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Label, {
          children: [t('rassrochka.month_payment'), ":"]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Output_Note, {
          monthly: true,
          children: [(0,common/* normalizePrice */.nQ)(output.monthlyPayment), " ", currency]
        })]
      })]
    })]
  });
}

/* harmony default export */ var components_Output = (Output);
const Output_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Component",
  componentId: "sc-ljo2eq-0"
})(["max-width:480px;padding:10px 15px;margin-top:20px;background-color:", ";border-radius:5px;"], theme/* colors.primary */.O9.primary);
const Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Item",
  componentId: "sc-ljo2eq-1"
})(["display:flex;align-items:center;"]);
const Output_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Label",
  componentId: "sc-ljo2eq-2"
})(["font-style:normal;font-weight:600;font-size:14px;line-height:30px;color:", ";"], theme/* colors.white */.O9.white);
const Output_Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Note",
  componentId: "sc-ljo2eq-3"
})(["font-style:normal;font-weight:", ";font-size:20px;line-height:30px;color:", ";"], ({
  monthly
}) => monthly ? '600' : 'normal', theme/* colors.white */.O9.white);
const Output_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Output__Content",
  componentId: "sc-ljo2eq-4"
})(["margin-left:11px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/CardCalculator/ProductCalculator.tsx


function ProductCalculator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function ProductCalculator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ProductCalculator_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ProductCalculator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


















const initOutputState = {
  price: 0,
  underpayment: 0,
  monthlyPayment: 0
};
const initialState = {
  periodSelected: 0,
  price: 1000,
  initPaymentRate: 25,
  rate: 0,
  initialPayment: (0,Calculator_helpers/* getQuarterToString */.N)(1000, 25)
};

const calcReducer = (state, action) => {
  const {
    type,
    payload
  } = action;

  switch (type) {
    case Clculator_typings/* ActionType.SETPERIOD */.U.SETPERIOD:
      return ProductCalculator_objectSpread(ProductCalculator_objectSpread({}, state), {}, {
        periodSelected: payload
      });

    case Clculator_typings/* ActionType.SETPRICE */.U.SETPRICE:
      return ProductCalculator_objectSpread(ProductCalculator_objectSpread({}, state), {}, {
        price: payload
      });

    case Clculator_typings/* ActionType.SETINITPAYMENTRATE */.U.SETINITPAYMENTRATE:
      return ProductCalculator_objectSpread(ProductCalculator_objectSpread({}, state), {}, {
        initPaymentRate: payload
      });

    case Clculator_typings/* ActionType.SETRATE */.U.SETRATE:
      return ProductCalculator_objectSpread(ProductCalculator_objectSpread({}, state), {}, {
        rate: payload
      });

    case Clculator_typings/* ActionType.SETINITIALPAYMENT */.U.SETINITIALPAYMENT:
      return ProductCalculator_objectSpread(ProductCalculator_objectSpread({}, state), {}, {
        initialPayment: payload
      });

    default:
      return state;
  }
};

function ProductCalculator({
  closeModal,
  innerProps
}) {
  const {
    0: state,
    1: dispatch
  } = (0,react.useReducer)(calcReducer, initialState);
  const {
    0: outputData,
    1: setOutputData
  } = (0,react.useState)(initOutputState);
  const creditPrices = (0,hooks/* useSettingItem */.qT)('PRICES_CREDIT');
  const {
    closeModalState,
    openModalState
  } = (0,useModalsOpen/* default */.Z)();
  const setPeriodAndRate = (0,react.useCallback)(periodIndex => {
    const period = creditPrices[periodIndex].period;
    const rate = creditPrices[periodIndex].underPayment;

    if (period && Number(period) !== state.periodSelected) {
      dispatch({
        type: Clculator_typings/* ActionType.SETPERIOD */.U.SETPERIOD,
        payload: Number(period)
      });
      dispatch({
        type: Clculator_typings/* ActionType.SETRATE */.U.SETRATE,
        payload: Number(rate)
      });
    }
  }, [creditPrices, state.periodSelected]);

  const getFirstCost = e => {
    dispatch({
      type: Clculator_typings/* ActionType.SETINITIALPAYMENT */.U.SETINITIALPAYMENT,
      payload: Number(e.target.value.trim())
    });
  };

  (0,react.useEffect)(() => {
    const {
      period,
      initial,
      underPayment
    } = creditPrices[0];

    if (period) {
      dispatch({
        type: Clculator_typings/* ActionType.SETPERIOD */.U.SETPERIOD,
        payload: Number(period)
      });
    }

    if (initial) {
      dispatch({
        type: Clculator_typings/* ActionType.SETINITPAYMENTRATE */.U.SETINITPAYMENTRATE,
        payload: Number(initial)
      });
    }

    if (underPayment) {
      dispatch({
        type: Clculator_typings/* ActionType.SETRATE */.U.SETRATE,
        payload: Number(underPayment)
      });
    }
  }, [creditPrices]);
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  (0,react.useEffect)(() => {
    var _innerProps$productPr;

    const data = (0,Calculator_helpers/* getFinalPrice */.e)((_innerProps$productPr = innerProps.productPrice) !== null && _innerProps$productPr !== void 0 ? _innerProps$productPr : 1000, state.rate, state.initialPayment, state.periodSelected);
    setOutputData(data);
  }, [state.rate, state.initialPayment, state.periodSelected, innerProps.productPrice]);
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: t('rassrochka.title')
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, {
        onClick: () => {
          closeModal();
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Content, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Item, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Label, {
            children: [t('rassrochka.price'), ", ", currency]
          }), innerProps !== null && innerProps !== void 0 && innerProps.productPrice && innerProps.productPrice !== 0 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Value, {
            children: [(0,common/* normalizePrice */.nQ)(innerProps.productPrice), " ", currency]
          }) : null]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Item, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProductCalculator_Label, {
            children: t('rassrochka.period')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CalculatorSelect, {
            setData: setPeriodAndRate,
            data: creditPrices
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Item, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ProductCalculator_Label, {
            children: [t('rassrochka.initial_payment'), " (", t('dimensions.from'), " 25%)"]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_CalculatorInput, {
            value: state.initialPayment,
            icon: "wallet",
            onChange: getFirstCost
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Output, {
          output: outputData
        })]
      })
    })]
  });
}

/* harmony default export */ var CardCalculator_ProductCalculator = (ProductCalculator);
const ProductCalculator_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Component",
  componentId: "sc-w0xexr-0"
})(["background:", ";padding-bottom:17px;width:min(100vw,500px);height:min(calc(var(--vh,1) * 100),80vh);-webkit-overflow-scrolling:touch !important;overflow:auto !important;"], theme/* colors.white */.O9.white);
const ProductCalculator_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Content",
  componentId: "sc-w0xexr-1"
})([""]);
const ProductCalculator_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Header",
  componentId: "sc-w0xexr-2"
})(["height:45px;position:relative;padding:5px 15px;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 6px 0 #d0d0d0;"]);
const StyledIcon = (0,styled_components_browser_esm["default"])(Modals_close/* ReactComponent */.r).withConfig({
  displayName: "ProductCalculator__StyledIcon",
  componentId: "sc-w0xexr-3"
})(["position:absolute;top:50%;right:15px;transform:translateY(-50%);cursor:pointer;margin-left:15px;"]);
const Title = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Title",
  componentId: "sc-w0xexr-4"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;"]);
const ProductCalculator_Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Item",
  componentId: "sc-w0xexr-5"
})(["margin-top:19px;max-width:480px;"]);
const ProductCalculator_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Label",
  componentId: "sc-w0xexr-6"
})(["margin-bottom:7px;font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"]);
const Value = styled_components_browser_esm["default"].div.withConfig({
  displayName: "ProductCalculator__Value",
  componentId: "sc-w0xexr-7"
})(["font-style:normal;font-weight:600;font-size:30px;line-height:26px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/CardCalculator/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Price/Price.tsx














function Price() {
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const {
    price,
    discountPrice
  } = (0,react.useContext)(productContext);
  const t = (0,production/* useTranslations */.T_)();
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Price_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(PriceWrapper, {
        children: [price ? /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceLabel, {
          isDiscount: !!discountPrice,
          children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
        }) : null, discountPrice ? /*#__PURE__*/(0,jsx_runtime.jsxs)(PriceLabel, {
          children: [(0,common/* normalizePrice */.nQ)(discountPrice), " ", currency]
        }) : null]
      }), (0,common/* getCurrentProject */.vo)() !== 'dveri' && /*#__PURE__*/(0,jsx_runtime.jsxs)(CalcButton, {
        onClick: () => {
          openModal(CardCalculator_ProductCalculator, {
            productPrice: price
          }, {
            withAnimation: false,
            scrollLockDisabled: true
          });
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Price_StyledIcon, {}), t('rassrochka.title')]
      })]
    })
  });
}

/* harmony default export */ var Price_Price = (Price);
const Price_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Price__Component",
  componentId: "sc-ugirai-0"
})(["padding-bottom:15px;margin-top:20px;border-bottom:1px solid ", ";"], theme/* colors.gray70 */.O9.gray70);
const PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Price__PriceWrapper",
  componentId: "sc-ugirai-1"
})(["display:flex;align-items:center;& > span:not(:first-child){margin-left:15px;}"]);
const PriceLabel = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Price__PriceLabel",
  componentId: "sc-ugirai-2"
})(["", ""], ({
  isDiscount
}) => isDiscount ? (0,styled_components_browser_esm.css)(["font-style:normal;font-weight:500;line-height:20px;text-decoration-line:line-through;font-size:18px;color:", ";"], theme/* colors.darkGrey */.O9.darkGrey) : (0,styled_components_browser_esm.css)(["font-style:normal;font-weight:600;font-size:30px;line-height:26px;color:", ";"], theme/* colors.black */.O9.black));
const DiscountLabel = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Price__DiscountLabel",
  componentId: "sc-ugirai-3"
})(["margin-left:16px;font-style:normal;font-weight:600;font-size:30px;line-height:26px;"]);
const CalcButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "Price__CalcButton",
  componentId: "sc-ugirai-4"
})(["margin-top:2px;display:flex;align-items:center;max-width:480px;font-style:normal;font-weight:600;font-size:13px;line-height:24px;color:", ";"], theme/* colors.primary */.O9.primary);
const Price_StyledIcon = (0,styled_components_browser_esm["default"])(SvgCalculator).withConfig({
  displayName: "Price__StyledIcon",
  componentId: "sc-ugirai-5"
})(["margin-right:8px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Price/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Related/Related.tsx









function Related({
  product
}) {
  const {
    0: isOptionsOpen,
    1: setOpen
  } = (0,react.useState)(false);
  const {
    0: currentIndex,
    1: setIndex
  } = (0,react.useState)(0);
  const router = (0,next_router.useRouter)();
  const relatedList = (0,react.useMemo)(() => {
    var _product$related;

    if (!(product !== null && product !== void 0 && (_product$related = product.related) !== null && _product$related !== void 0 && _product$related.length)) {
      return null;
    }

    return product.related;
  }, [product === null || product === void 0 ? void 0 : product.related]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Related_Component, {
    children: !!(relatedList !== null && relatedList !== void 0 && relatedList.length) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Related_Content, {
      children: relatedList.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Related_Label, {
          children: item.name
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Related_SelectWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Related_StyledArrow, {
            isopen: isOptionsOpen
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Related_Select, {
            className: "multiprice-select",
            onFocus: () => {
              setOpen(pre => !pre);
            },
            onBlur: e => {
              e.target.click();
              setOpen(false);
            },
            onChange: e => {
              const index = e.target.selectedIndex;
              const alias = item.options[index].productAlias;

              if (index !== currentIndex) {
                setIndex(index);

                if (alias) {
                  router.push('/products/' + alias);
                }

                setOpen(pre => !pre);
              }
            },
            children: item.options.map((option, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Related_Option, {
              selected: index === currentIndex,
              isSelected: index === currentIndex,
              children: option.name
            }, index))
          })]
        })]
      }))
    }) : null
  });
}

/* harmony default export */ var Related_Related = (Related);
const Related_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Related__Component",
  componentId: "sc-1brzkc6-0"
})(["margin-top:17px;"]);
const Related_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Related__Label",
  componentId: "sc-1brzkc6-1"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;"]);
const Related_SelectWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Related__SelectWrapper",
  componentId: "sc-1brzkc6-2"
})(["margin-top:7px;min-height:34px;max-width:480px;overflow:hidden;border:1px solid ", ";border-radius:5px;position:relative;"], theme/* colors.gray70 */.O9.gray70);
const Related_Select = styled_components_browser_esm["default"].select.withConfig({
  displayName: "Related__Select",
  componentId: "sc-1brzkc6-3"
})(["position:absolute;padding-left:15px;height:100%;width:100%;cursor:pointer;outline:none;border:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;-ms-word-break:normal;word-break:normal;background:transparent;z-index:10;"]);
const Related_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Related__Content",
  componentId: "sc-1brzkc6-4"
})([""]);
const Related_Option = styled_components_browser_esm["default"].option.withConfig({
  displayName: "Related__Option",
  componentId: "sc-1brzkc6-5"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;", ""], ({
  isSelected
}) => isSelected ? (0,styled_components_browser_esm.css)(["color:", ";font-weight:600;"], theme/* colors.primary */.O9.primary) : (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.black */.O9.black));
const Related_StyledArrow = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "Related__StyledArrow",
  componentId: "sc-1brzkc6-6"
})(["position:absolute;top:50%;right:15px;transform:translateY(-50%) ", ";path{fill:rgba(0,0,0,1);}z-index:1;"], ({
  isopen
}) => isopen ? ' rotate(180deg)' : ' rotate(0)');
const Related_Description = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Related__Description",
  componentId: "sc-1brzkc6-7"
})(["margin-top:5px;font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.grayDark */.O9.grayDark);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Related/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/fabric.svg
function fabric_extends() { fabric_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fabric_extends.apply(this, arguments); }



var fabric_ref = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#clip0_1_733)"
}, /*#__PURE__*/react.createElement("path", {
  d: "M27.0405 8.58057H18.3497L25.1398 15.5042L27.0405 14.4667",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M8.50711 29.265H17.0778L29.7679 22.3342L28.8776 18.1411",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M27.9873 13.9556L0.770172 28.8259C0.883224 29.0853 1.13052 29.2654 1.42728 29.2654H8.5142L28.8776 18.1414L27.9873 13.9556Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M25.1398 15.5042L18.3497 8.58057H10.8883L20.2857 18.1627L25.1398 15.5042Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M10.8883 8.58057H2.62137L14.9016 21.1022L20.2857 18.1627L10.8883 8.58057Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M26.9769 23.8545L17.0779 29.2652H31.2446",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M31.2446 7.51416C28.92 7.51416 27.0405 9.43059 27.0405 11.8009V18.5516C27.0405 16.1813 28.92 14.2649 31.2446 14.2649C33.5692 14.2649 35.4487 16.1813 35.4487 18.5516V11.8009C35.4487 9.43059 33.5692 7.51416 31.2446 7.51416Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M31.2446 14.2654C28.92 14.2654 27.0405 16.1818 27.0405 18.5521V24.9786C27.0405 27.349 28.92 29.2654 31.2446 29.2654C33.5692 29.2654 35.4487 27.349 35.4487 24.9786V18.5521C35.4487 16.189 33.5692 14.2654 31.2446 14.2654Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M31.2446 0.734863C28.92 0.734863 27.0405 2.65129 27.0405 5.02161V11.8011C27.0405 9.43083 28.92 7.5144 31.2446 7.5144C33.5692 7.5144 35.4487 9.43083 35.4487 11.8011V5.02161C35.4487 2.65129 33.5692 0.734863 31.2446 0.734863Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M35.4487 24.9784C35.4487 27.3487 33.5692 29.2651 31.2446 29.2651C28.92 29.2651 27.0405 27.3487 27.0405 24.9784C27.0405 22.6081 28.92 20.6917 31.2446 20.6917C33.5692 20.6917 35.4487 22.6081 35.4487 24.9784Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M32.8697 24.9781C32.8697 25.8931 32.1419 26.6352 31.2446 26.6352C30.3473 26.6352 29.6195 25.8931 29.6195 24.9781C29.6195 24.0631 30.3473 23.321 31.2446 23.321C32.1419 23.321 32.8697 24.0631 32.8697 24.9781Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M6.07652 12.1038L0.706573 14.9928V19.5821L9.02292 15.1009L6.07652 12.1038Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M2.62138 8.58057H1.42728C1.0316 8.58057 0.706573 8.91198 0.706573 9.31544V14.9999L6.07652 12.1036L2.62138 8.58057Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M9.02292 15.1079L0.706573 19.582V24.1425L11.9481 18.0834L9.02292 15.1079Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M11.9481 18.0906L0.706573 24.1424V28.53C0.706573 28.6309 0.727771 28.7318 0.763099 28.8254L14.8945 21.1021L11.9481 18.0906Z",
  fill: "#BC557F"
}), /*#__PURE__*/react.createElement("path", {
  d: "M36.1765 5.02161C36.1765 2.25504 33.9649 0 31.2517 0C28.5384 0 26.3269 2.25504 26.3269 5.02161V7.85303H1.43434C0.64298 7.84582 0 8.50144 0 9.31556L0.0918543 29.049C0.268497 29.6182 0.869083 30 1.43434 30H31.2517C33.9649 30 36.1765 27.745 36.1765 24.9784V5.02161ZM26.3339 18.696L20.9075 21.6571C20.109 22.0893 20.7591 23.4006 21.5858 22.9467L26.3339 20.353V23.3718L16.9083 28.5303H11.3829L16.562 25.6988C17.3746 25.2522 16.6963 23.9625 15.8837 24.4092L8.33755 28.5303H2.83335L26.3339 15.6916V18.696ZM12.6335 9.31556H18.06L23.9598 15.3314L20.427 17.2622L12.6335 9.31556ZM7.83588 14.9207L1.43434 18.3718V15.4395L5.94933 13.0043L7.83588 14.9207ZM1.43434 20.0288L8.9028 16.0086L10.7682 17.9107L1.44141 22.9323L1.43434 20.0288ZM11.828 18.9914L13.7216 20.9222L1.43434 27.6297V24.5821L11.828 18.9914ZM26.3339 14.0274L25.2811 14.6037L20.0949 9.31556H26.3339V14.0274ZM19.1057 17.9827L15.0429 20.2017L4.36661 9.31556H10.6056L19.1057 17.9827ZM1.43434 9.31556H2.33169L4.88948 11.9236L1.43434 13.7824V9.31556ZM19.9536 28.5303L26.3339 25.0432C26.3481 26.4049 26.8992 27.6369 27.7824 28.5303H19.9536ZM31.2517 28.5303C29.3298 28.5303 27.7683 26.938 27.7683 24.9784C27.7683 23.0187 29.3298 21.4265 31.2517 21.4265C33.1735 21.4265 34.7351 23.0187 34.7351 24.9784C34.7351 26.938 33.1735 28.5303 31.2517 28.5303ZM31.2517 19.9568C29.888 19.9568 28.6585 20.5259 27.7683 21.4337V18.5519C27.7683 16.621 29.3581 15 31.2517 15C33.1453 15 34.7351 16.621 34.7351 18.5519V21.4337C33.8448 20.5259 32.6153 19.9568 31.2517 19.9568ZM34.6573 14.928C32.7496 13.062 29.6336 13.098 27.7683 15.0072V14.4669V14.4597V11.7939C27.7683 9.86311 29.3581 8.24207 31.2517 8.24207C33.1453 8.24207 34.7351 9.86311 34.7351 11.7939V15.0072C34.7139 14.9856 34.6856 14.9568 34.6573 14.928ZM34.6573 8.17723C32.7496 6.31124 29.6336 6.34726 27.7683 8.25648V5.01441C27.7683 3.05475 29.3298 1.46254 31.2517 1.46254C33.1735 1.46254 34.7351 3.05475 34.7351 5.01441V8.25648C34.7139 8.23487 34.6856 8.20605 34.6573 8.17723C34.6291 8.14841 34.6856 8.20605 34.6573 8.17723Z",
  fill: "black"
}), /*#__PURE__*/react.createElement("path", {
  d: "M31.2516 22.5867C29.9586 22.5867 28.9058 23.6602 28.9058 24.9786C28.9058 26.297 29.9586 27.3705 31.2516 27.3705C32.5447 27.3705 33.5975 26.297 33.5975 24.9786C33.5975 23.6602 32.5447 22.5867 31.2516 22.5867ZM31.2516 25.9008C30.75 25.9008 30.3472 25.4829 30.3472 24.9714C30.3472 24.4599 30.7571 24.0492 31.2516 24.0492C31.7533 24.0492 32.1631 24.4671 32.1631 24.9714C32.1631 25.4757 31.7533 25.9008 31.2516 25.9008Z",
  fill: "black"
}), /*#__PURE__*/react.createElement("path", {
  d: "M18.7171 22.8965C18.3285 22.8965 17.9964 23.2279 17.9964 23.6314C17.9964 24.0276 18.3214 24.3662 18.7171 24.3662C19.0986 24.3662 19.4166 24.0492 19.4307 23.6674C19.4519 23.2495 19.1198 22.8965 18.7171 22.8965Z",
  fill: "black"
}));

var _ref2 = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "clip0_1_733"
}, /*#__PURE__*/react.createElement("rect", {
  width: 36.1765,
  height: 30,
  fill: "white"
})));

function SvgFabric({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", fabric_extends({
    width: 37,
    height: 30,
    viewBox: "0 0 37 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, fabric_ref, _ref2);
}

/* harmony default export */ var fabric = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzNyAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfNzMzKSI+CjxwYXRoIGQ9Ik0yNy4wNDA1IDguNTgwNTdIMTguMzQ5N0wyNS4xMzk4IDE1LjUwNDJMMjcuMDQwNSAxNC40NjY3IiBmaWxsPSIjQkM1NTdGIi8+CjxwYXRoIGQ9Ik04LjUwNzExIDI5LjI2NUgxNy4wNzc4TDI5Ljc2NzkgMjIuMzM0MkwyOC44Nzc2IDE4LjE0MTEiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTI3Ljk4NzMgMTMuOTU1NkwwLjc3MDE3MiAyOC44MjU5QzAuODgzMjI0IDI5LjA4NTMgMS4xMzA1MiAyOS4yNjU0IDEuNDI3MjggMjkuMjY1NEg4LjUxNDJMMjguODc3NiAxOC4xNDE0TDI3Ljk4NzMgMTMuOTU1NloiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTI1LjEzOTggMTUuNTA0MkwxOC4zNDk3IDguNTgwNTdIMTAuODg4M0wyMC4yODU3IDE4LjE2MjdMMjUuMTM5OCAxNS41MDQyWiIgZmlsbD0iI0JDNTU3RiIvPgo8cGF0aCBkPSJNMTAuODg4MyA4LjU4MDU3SDIuNjIxMzdMMTQuOTAxNiAyMS4xMDIyTDIwLjI4NTcgMTguMTYyN0wxMC44ODgzIDguNTgwNTdaIiBmaWxsPSIjQkM1NTdGIi8+CjxwYXRoIGQ9Ik0yNi45NzY5IDIzLjg1NDVMMTcuMDc3OSAyOS4yNjUySDMxLjI0NDYiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTMxLjI0NDYgNy41MTQxNkMyOC45MiA3LjUxNDE2IDI3LjA0MDUgOS40MzA1OSAyNy4wNDA1IDExLjgwMDlWMTguNTUxNkMyNy4wNDA1IDE2LjE4MTMgMjguOTIgMTQuMjY0OSAzMS4yNDQ2IDE0LjI2NDlDMzMuNTY5MiAxNC4yNjQ5IDM1LjQ0ODcgMTYuMTgxMyAzNS40NDg3IDE4LjU1MTZWMTEuODAwOUMzNS40NDg3IDkuNDMwNTkgMzMuNTY5MiA3LjUxNDE2IDMxLjI0NDYgNy41MTQxNloiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTMxLjI0NDYgMTQuMjY1NEMyOC45MiAxNC4yNjU0IDI3LjA0MDUgMTYuMTgxOCAyNy4wNDA1IDE4LjU1MjFWMjQuOTc4NkMyNy4wNDA1IDI3LjM0OSAyOC45MiAyOS4yNjU0IDMxLjI0NDYgMjkuMjY1NEMzMy41NjkyIDI5LjI2NTQgMzUuNDQ4NyAyNy4zNDkgMzUuNDQ4NyAyNC45Nzg2VjE4LjU1MjFDMzUuNDQ4NyAxNi4xODkgMzMuNTY5MiAxNC4yNjU0IDMxLjI0NDYgMTQuMjY1NFoiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTMxLjI0NDYgMC43MzQ4NjNDMjguOTIgMC43MzQ4NjMgMjcuMDQwNSAyLjY1MTI5IDI3LjA0MDUgNS4wMjE2MVYxMS44MDExQzI3LjA0MDUgOS40MzA4MyAyOC45MiA3LjUxNDQgMzEuMjQ0NiA3LjUxNDRDMzMuNTY5MiA3LjUxNDQgMzUuNDQ4NyA5LjQzMDgzIDM1LjQ0ODcgMTEuODAxMVY1LjAyMTYxQzM1LjQ0ODcgMi42NTEyOSAzMy41NjkyIDAuNzM0ODYzIDMxLjI0NDYgMC43MzQ4NjNaIiBmaWxsPSIjQkM1NTdGIi8+CjxwYXRoIGQ9Ik0zNS40NDg3IDI0Ljk3ODRDMzUuNDQ4NyAyNy4zNDg3IDMzLjU2OTIgMjkuMjY1MSAzMS4yNDQ2IDI5LjI2NTFDMjguOTIgMjkuMjY1MSAyNy4wNDA1IDI3LjM0ODcgMjcuMDQwNSAyNC45Nzg0QzI3LjA0MDUgMjIuNjA4MSAyOC45MiAyMC42OTE3IDMxLjI0NDYgMjAuNjkxN0MzMy41NjkyIDIwLjY5MTcgMzUuNDQ4NyAyMi42MDgxIDM1LjQ0ODcgMjQuOTc4NFoiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTMyLjg2OTcgMjQuOTc4MUMzMi44Njk3IDI1Ljg5MzEgMzIuMTQxOSAyNi42MzUyIDMxLjI0NDYgMjYuNjM1MkMzMC4zNDczIDI2LjYzNTIgMjkuNjE5NSAyNS44OTMxIDI5LjYxOTUgMjQuOTc4MUMyOS42MTk1IDI0LjA2MzEgMzAuMzQ3MyAyMy4zMjEgMzEuMjQ0NiAyMy4zMjFDMzIuMTQxOSAyMy4zMjEgMzIuODY5NyAyNC4wNjMxIDMyLjg2OTcgMjQuOTc4MVoiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTYuMDc2NTIgMTIuMTAzOEwwLjcwNjU3MyAxNC45OTI4VjE5LjU4MjFMOS4wMjI5MiAxNS4xMDA5TDYuMDc2NTIgMTIuMTAzOFoiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTIuNjIxMzggOC41ODA1N0gxLjQyNzI4QzEuMDMxNiA4LjU4MDU3IDAuNzA2NTczIDguOTExOTggMC43MDY1NzMgOS4zMTU0NFYxNC45OTk5TDYuMDc2NTIgMTIuMTAzNkwyLjYyMTM4IDguNTgwNTdaIiBmaWxsPSIjQkM1NTdGIi8+CjxwYXRoIGQ9Ik05LjAyMjkyIDE1LjEwNzlMMC43MDY1NzMgMTkuNTgyVjI0LjE0MjVMMTEuOTQ4MSAxOC4wODM0TDkuMDIyOTIgMTUuMTA3OVoiIGZpbGw9IiNCQzU1N0YiLz4KPHBhdGggZD0iTTExLjk0ODEgMTguMDkwNkwwLjcwNjU3MyAyNC4xNDI0VjI4LjUzQzAuNzA2NTczIDI4LjYzMDkgMC43Mjc3NzEgMjguNzMxOCAwLjc2MzA5OSAyOC44MjU0TDE0Ljg5NDUgMjEuMTAyMUwxMS45NDgxIDE4LjA5MDZaIiBmaWxsPSIjQkM1NTdGIi8+CjxwYXRoIGQ9Ik0zNi4xNzY1IDUuMDIxNjFDMzYuMTc2NSAyLjI1NTA0IDMzLjk2NDkgMCAzMS4yNTE3IDBDMjguNTM4NCAwIDI2LjMyNjkgMi4yNTUwNCAyNi4zMjY5IDUuMDIxNjFWNy44NTMwM0gxLjQzNDM0QzAuNjQyOTggNy44NDU4MiAwIDguNTAxNDQgMCA5LjMxNTU2TDAuMDkxODU0MyAyOS4wNDlDMC4yNjg0OTcgMjkuNjE4MiAwLjg2OTA4MyAzMCAxLjQzNDM0IDMwSDMxLjI1MTdDMzMuOTY0OSAzMCAzNi4xNzY1IDI3Ljc0NSAzNi4xNzY1IDI0Ljk3ODRWNS4wMjE2MVpNMjYuMzMzOSAxOC42OTZMMjAuOTA3NSAyMS42NTcxQzIwLjEwOSAyMi4wODkzIDIwLjc1OTEgMjMuNDAwNiAyMS41ODU4IDIyLjk0NjdMMjYuMzMzOSAyMC4zNTNWMjMuMzcxOEwxNi45MDgzIDI4LjUzMDNIMTEuMzgyOUwxNi41NjIgMjUuNjk4OEMxNy4zNzQ2IDI1LjI1MjIgMTYuNjk2MyAyMy45NjI1IDE1Ljg4MzcgMjQuNDA5Mkw4LjMzNzU1IDI4LjUzMDNIMi44MzMzNUwyNi4zMzM5IDE1LjY5MTZWMTguNjk2Wk0xMi42MzM1IDkuMzE1NTZIMTguMDZMMjMuOTU5OCAxNS4zMzE0TDIwLjQyNyAxNy4yNjIyTDEyLjYzMzUgOS4zMTU1NlpNNy44MzU4OCAxNC45MjA3TDEuNDM0MzQgMTguMzcxOFYxNS40Mzk1TDUuOTQ5MzMgMTMuMDA0M0w3LjgzNTg4IDE0LjkyMDdaTTEuNDM0MzQgMjAuMDI4OEw4LjkwMjggMTYuMDA4NkwxMC43NjgyIDE3LjkxMDdMMS40NDE0MSAyMi45MzIzTDEuNDM0MzQgMjAuMDI4OFpNMTEuODI4IDE4Ljk5MTRMMTMuNzIxNiAyMC45MjIyTDEuNDM0MzQgMjcuNjI5N1YyNC41ODIxTDExLjgyOCAxOC45OTE0Wk0yNi4zMzM5IDE0LjAyNzRMMjUuMjgxMSAxNC42MDM3TDIwLjA5NDkgOS4zMTU1NkgyNi4zMzM5VjE0LjAyNzRaTTE5LjEwNTcgMTcuOTgyN0wxNS4wNDI5IDIwLjIwMTdMNC4zNjY2MSA5LjMxNTU2SDEwLjYwNTZMMTkuMTA1NyAxNy45ODI3Wk0xLjQzNDM0IDkuMzE1NTZIMi4zMzE2OUw0Ljg4OTQ4IDExLjkyMzZMMS40MzQzNCAxMy43ODI0VjkuMzE1NTZaTTE5Ljk1MzYgMjguNTMwM0wyNi4zMzM5IDI1LjA0MzJDMjYuMzQ4MSAyNi40MDQ5IDI2Ljg5OTIgMjcuNjM2OSAyNy43ODI0IDI4LjUzMDNIMTkuOTUzNlpNMzEuMjUxNyAyOC41MzAzQzI5LjMyOTggMjguNTMwMyAyNy43NjgzIDI2LjkzOCAyNy43NjgzIDI0Ljk3ODRDMjcuNzY4MyAyMy4wMTg3IDI5LjMyOTggMjEuNDI2NSAzMS4yNTE3IDIxLjQyNjVDMzMuMTczNSAyMS40MjY1IDM0LjczNTEgMjMuMDE4NyAzNC43MzUxIDI0Ljk3ODRDMzQuNzM1MSAyNi45MzggMzMuMTczNSAyOC41MzAzIDMxLjI1MTcgMjguNTMwM1pNMzEuMjUxNyAxOS45NTY4QzI5Ljg4OCAxOS45NTY4IDI4LjY1ODUgMjAuNTI1OSAyNy43NjgzIDIxLjQzMzdWMTguNTUxOUMyNy43NjgzIDE2LjYyMSAyOS4zNTgxIDE1IDMxLjI1MTcgMTVDMzMuMTQ1MyAxNSAzNC43MzUxIDE2LjYyMSAzNC43MzUxIDE4LjU1MTlWMjEuNDMzN0MzMy44NDQ4IDIwLjUyNTkgMzIuNjE1MyAxOS45NTY4IDMxLjI1MTcgMTkuOTU2OFpNMzQuNjU3MyAxNC45MjhDMzIuNzQ5NiAxMy4wNjIgMjkuNjMzNiAxMy4wOTggMjcuNzY4MyAxNS4wMDcyVjE0LjQ2NjlWMTQuNDU5N1YxMS43OTM5QzI3Ljc2ODMgOS44NjMxMSAyOS4zNTgxIDguMjQyMDcgMzEuMjUxNyA4LjI0MjA3QzMzLjE0NTMgOC4yNDIwNyAzNC43MzUxIDkuODYzMTEgMzQuNzM1MSAxMS43OTM5VjE1LjAwNzJDMzQuNzEzOSAxNC45ODU2IDM0LjY4NTYgMTQuOTU2OCAzNC42NTczIDE0LjkyOFpNMzQuNjU3MyA4LjE3NzIzQzMyLjc0OTYgNi4zMTEyNCAyOS42MzM2IDYuMzQ3MjYgMjcuNzY4MyA4LjI1NjQ4VjUuMDE0NDFDMjcuNzY4MyAzLjA1NDc1IDI5LjMyOTggMS40NjI1NCAzMS4yNTE3IDEuNDYyNTRDMzMuMTczNSAxLjQ2MjU0IDM0LjczNTEgMy4wNTQ3NSAzNC43MzUxIDUuMDE0NDFWOC4yNTY0OEMzNC43MTM5IDguMjM0ODcgMzQuNjg1NiA4LjIwNjA1IDM0LjY1NzMgOC4xNzcyM0MzNC42MjkxIDguMTQ4NDEgMzQuNjg1NiA4LjIwNjA1IDM0LjY1NzMgOC4xNzcyM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0zMS4yNTE2IDIyLjU4NjdDMjkuOTU4NiAyMi41ODY3IDI4LjkwNTggMjMuNjYwMiAyOC45MDU4IDI0Ljk3ODZDMjguOTA1OCAyNi4yOTcgMjkuOTU4NiAyNy4zNzA1IDMxLjI1MTYgMjcuMzcwNUMzMi41NDQ3IDI3LjM3MDUgMzMuNTk3NSAyNi4yOTcgMzMuNTk3NSAyNC45Nzg2QzMzLjU5NzUgMjMuNjYwMiAzMi41NDQ3IDIyLjU4NjcgMzEuMjUxNiAyMi41ODY3Wk0zMS4yNTE2IDI1LjkwMDhDMzAuNzUgMjUuOTAwOCAzMC4zNDcyIDI1LjQ4MjkgMzAuMzQ3MiAyNC45NzE0QzMwLjM0NzIgMjQuNDU5OSAzMC43NTcxIDI0LjA0OTIgMzEuMjUxNiAyNC4wNDkyQzMxLjc1MzMgMjQuMDQ5MiAzMi4xNjMxIDI0LjQ2NzEgMzIuMTYzMSAyNC45NzE0QzMyLjE2MzEgMjUuNDc1NyAzMS43NTMzIDI1LjkwMDggMzEuMjUxNiAyNS45MDA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE4LjcxNzEgMjIuODk2NUMxOC4zMjg1IDIyLjg5NjUgMTcuOTk2NCAyMy4yMjc5IDE3Ljk5NjQgMjMuNjMxNEMxNy45OTY0IDI0LjAyNzYgMTguMzIxNCAyNC4zNjYyIDE4LjcxNzEgMjQuMzY2MkMxOS4wOTg2IDI0LjM2NjIgMTkuNDE2NiAyNC4wNDkyIDE5LjQzMDcgMjMuNjY3NEMxOS40NTE5IDIzLjI0OTUgMTkuMTE5OCAyMi44OTY1IDE4LjcxNzEgMjIuODk2NVoiIGZpbGw9ImJsYWNrIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMV83MzMiPgo8cmVjdCB3aWR0aD0iMzYuMTc2NSIgaGVpZ2h0PSIzMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");

// EXTERNAL MODULE: ./src/components/Button/Button.tsx + 1 modules
var Button = __webpack_require__(99492);
;// CONCATENATED MODULE: ./src/components/Button/FabricButton.tsx


const FabricButton_excluded = ["children", "onClick"];

function FabricButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function FabricButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { FabricButton_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { FabricButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








function FabricButton(_ref) {
  let {
    children,
    onClick
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, FabricButton_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Button/* default */.Co, FabricButton_objectSpread(FabricButton_objectSpread({
    onClick: onClick
  }, rest), {}, {
    variant: 'outlined-primary-w100-f14',
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(FabricButton_StyledIcon, {})]
  }));
}

/* harmony default export */ var Button_FabricButton = (FabricButton);
const FabricButton_StyledIcon = (0,styled_components_browser_esm["default"])(SvgFabric).withConfig({
  displayName: "FabricButton__StyledIcon",
  componentId: "sc-ipihg3-0"
})(["position:absolute;top:50%;transform:translateY(-50%);left:12px;"]);
;// CONCATENATED MODULE: ./src/assets/svg/under-construction.svg
function under_construction_extends() { under_construction_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return under_construction_extends.apply(this, arguments); }



function SvgUnderConstruction({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", under_construction_extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#D4D2D3"
    },
    d: "M66.823,41.807h-28.19c-8.133,0-14.725,6.593-14.725,14.725v401.711c0,6.6,5.351,11.95,11.95,11.95 h33.74c6.6,0,11.95-5.351,11.95-11.95V56.532C81.548,48.399,74.955,41.807,66.823,41.807z"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#D4D2D3"
    },
    d: "M445.177,41.807h28.19c8.133,0,14.725,6.593,14.725,14.725v401.711c0,6.6-5.351,11.95-11.95,11.95 h-33.74c-6.6,0-11.95-5.351-11.95-11.95V56.532C430.452,48.399,437.045,41.807,445.177,41.807z"
  }), /*#__PURE__*/react.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "74.425,78.967 25.806,101.334 0,153.394 0,233.703 101.506,171.355 154.735,78.967  "
  }), /*#__PURE__*/react.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "228.749,78.967 101.506,171.355 43.974,263.742 124.284,263.742 240.516,188.731 309.058,78.967  "
  }), /*#__PURE__*/react.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "383.071,78.967 240.516,188.731 198.296,263.742 278.606,263.742 395.303,184.671 463.381,78.967  "
  }), /*#__PURE__*/react.createElement("polygon", {
    style: {
      fill: "#465059"
    },
    points: "383.071,201.118 352.62,263.742 432.929,263.742 490.323,233.703 512,184.671 512,104.361 "
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M512,184.671v55.164c0,13.203-10.705,23.907-23.907,23.907h-55.164L512,184.671z"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M512,102.875v1.487l-159.38,159.38h-74.013L463.381,78.967h24.712 C501.295,78.967,512,89.672,512,102.875z"
  }), /*#__PURE__*/react.createElement("polygon", {
    style: {
      fill: "#FFCD38"
    },
    points: "383.071,78.967 198.296,263.742 124.284,263.742 309.058,78.967  "
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M228.749,78.967L43.974,263.742H23.907C10.705,263.742,0,253.037,0,239.834v-6.132L154.735,78.967 H228.749z"
  }), /*#__PURE__*/react.createElement("path", {
    style: {
      fill: "#FFCD38"
    },
    d: "M74.425,78.967L0,153.394v-50.519c0-13.203,10.705-23.907,23.907-23.907H74.425z"
  }), /*#__PURE__*/react.createElement("rect", {
    x: 23.911,
    y: 263.737,
    style: {
      fill: "#BAB8B9"
    },
    width: 57.642,
    height: 31.101
  }), /*#__PURE__*/react.createElement("rect", {
    x: 430.451,
    y: 263.737,
    style: {
      fill: "#BAB8B9"
    },
    width: 57.642,
    height: 31.101
  }));
}

/* harmony default export */ var under_construction = ("data:image/svg+xml;base64,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");

// EXTERNAL MODULE: ./src/components/Helper/index.ts + 1 modules
var Helper = __webpack_require__(55864);
// EXTERNAL MODULE: ./src/components/Button/index.ts
var components_Button = __webpack_require__(91533);
;// CONCATENATED MODULE: ./src/components/modals/shared/styles.ts


const styles_Container = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1e2613f-0"
})(["min-width:290px;max-width:600px;width:100%;background-color:#ffffff;box-shadow:0 0 15px rgba(0,0,0,0.15);"]);
const styles_Header = styled_components_browser_esm["default"].header.withConfig({
  displayName: "styles__Header",
  componentId: "sc-1e2613f-1"
})(["position:relative;min-height:45px;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 6px 0 #d0d0d0;padding:0 15px;"]);
const HeaderTitle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styles__HeaderTitle",
  componentId: "sc-1e2613f-2"
})(["font-style:normal;font-weight:500;font-size:18px;line-height:24px;text-align:center;padding-right:25px;flex-grow:1;"]);
const styles_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "styles__Content",
  componentId: "sc-1e2613f-3"
})(["padding:20px;position:relative;"]);
const Footer = styled_components_browser_esm["default"].footer.withConfig({
  displayName: "styles__Footer",
  componentId: "sc-1e2613f-4"
})(["display:flex;justify-content:flex-end;align-items:center;padding:20px;border-top:1px solid #ccc;"]);
const FooterButton = (0,styled_components_browser_esm["default"])(components_Button/* default */.C).withConfig({
  displayName: "styles__FooterButton",
  componentId: "sc-1e2613f-5"
})(["margin-left:20px;height:40px;width:100px;"]);
;// CONCATENATED MODULE: ./src/assets/svg/close.svg
function close_extends() { close_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return close_extends.apply(this, arguments); }



var close_ref = /*#__PURE__*/react.createElement("path", {
  d: "M0 0h24v24H0z",
  fill: "none"
});

var close_ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
});

function SvgClose({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", close_extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, close_ref, close_ref2);
}

/* harmony default export */ var svg_close = ("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5IDYuNDFMMTcuNTkgNSAxMiAxMC41OSA2LjQxIDUgNSA2LjQxIDEwLjU5IDEyIDUgMTcuNTkgNi40MSAxOSAxMiAxMy40MSAxNy41OSAxOSAxOSAxNy41OSAxMy40MSAxMnoiLz48L3N2Zz4=");

;// CONCATENATED MODULE: ./src/components/modals/shared/CloseButton.tsx


function CloseButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function CloseButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { CloseButton_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { CloseButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






function CloseButton(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButton, CloseButton_objectSpread(CloseButton_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgClose, {})
  }));
}

const StyledButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "CloseButton__StyledButton",
  componentId: "sc-dl37og-0"
})(["border-radius:50%;transition:background-color 0.1s;&:hover{background-color:rgba(0,0,0,0.1);}svg{display:block;fill:currentColor;}"]);
/* harmony default export */ var shared_CloseButton = (CloseButton);
;// CONCATENATED MODULE: ./src/components/Forms/InProgressForm/InProgressForm.tsx











function InProgressForm({
  innerProps,
  closeModal
}) {
  const {
    title
  } = innerProps;
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(InProgressForm_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(InProgressForm_Content, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles_Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderTitle, {
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCloseButton, {
          onClick: closeModal
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Main, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(InProgressForm_StyledIcon, {})
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bottom, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Helper/* default */.Z, {})
      })]
    })
  });
}

/* harmony default export */ var InProgressForm_InProgressForm = (InProgressForm);
const InProgressForm_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InProgressForm__Component",
  componentId: "sc-1p8yu44-0"
})(["height:min(calc(var(--vh,1) * 100),80vh);min-width:min(100vw,500px);padding-bottom:15px;background:#fff;flex-shrink:1;-webkit-overflow-scrolling:touch !important;overflow:auto !important;position:relative;"]);
const StyledCloseButton = (0,styled_components_browser_esm["default"])(shared_CloseButton).withConfig({
  displayName: "InProgressForm__StyledCloseButton",
  componentId: "sc-1p8yu44-1"
})(["position:absolute;top:50%;transform:translateY(-50%);right:15px;"]);
const InProgressForm_StyledIcon = (0,styled_components_browser_esm["default"])(SvgUnderConstruction).withConfig({
  displayName: "InProgressForm__StyledIcon",
  componentId: "sc-1p8yu44-2"
})(["max-width:150px;height:150px;"]);
const InProgressForm_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InProgressForm__Content",
  componentId: "sc-1p8yu44-3"
})([""]);
const Main = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InProgressForm__Main",
  componentId: "sc-1p8yu44-4"
})(["padding:20px;display:flex;align-items:center;justify-content:center;border-bottom:1px dashed ", ";"], theme/* colors.gray50 */.O9.gray50);
const Bottom = styled_components_browser_esm["default"].div.withConfig({
  displayName: "InProgressForm__Bottom",
  componentId: "sc-1p8yu44-5"
})([""]);
;// CONCATENATED MODULE: ./src/components/Forms/InProgressForm/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Brand/Material/Material.tsx








function Material() {
  const t = (0,production/* useTranslations */.T_)();
  const openModal = (0,web_components_esm/* useModal */.dd)();

  const handler = () => {
    openModal(InProgressForm_InProgressForm, {
      title: t('material_unavailable')
    }, {
      withAnimation: false,
      scrollLockDisabled: true
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Material_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(FabricStyledIcon, {
      onClick: handler,
      children: t('material_select')
    })
  });
}

/* harmony default export */ var Material_Material = (Material);
const Material_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Material__Component",
  componentId: "sc-gpflzn-0"
})([""]);
const FabricStyledIcon = (0,styled_components_browser_esm["default"])(Button_FabricButton).withConfig({
  displayName: "Material__FabricStyledIcon",
  componentId: "sc-gpflzn-1"
})(["max-width:480px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Brand/Material/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Brand/Brand.tsx











function Brand({
  product
}) {
  var _dataList$brand;

  const t = (0,production/* useTranslations */.T_)();
  const dataList = (0,react.useMemo)(() => {
    const brand = [];
    const size = [];
    const sleepingSize = [];

    if (product !== null && product !== void 0 && product.brand) {
      brand.push({
        label: t('manufacturer'),
        text: product.brand.name,
        to: '/brands/' + product.brand.urlAlias
      });
    }

    if (product !== null && product !== void 0 && product.collection) {
      brand.push({
        label: t('collection'),
        text: product.collection.name,
        to: '/collections/' + product.collection.urlAlias
      });
    }

    if (product !== null && product !== void 0 && product.params) {
      product.params.forEach(param => {
        if (param.field.name === 'MEHANIZM-TRANSFORMACII') {
          var _param$value;

          brand.push({
            label: param.field.label,
            text: (_param$value = param.value) === null || _param$value === void 0 ? void 0 : _param$value.label
          });
        }

        if (param.field.name === 'DLINA') {
          size.push({
            label: param.field.label,
            text: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm')
          });
        }

        if (param.field.name === 'VYSOTA') {
          size.push({
            label: param.field.label,
            text: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm')
          });
        }

        if (param.field.name === 'GLUBINA') {
          size.push({
            label: param.field.label,
            text: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm')
          });
        }

        if (param.field.name === 'DLINA-SPALNOGO-MESTA') {
          sleepingSize.push({
            label: t('params.param_6'),
            text: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm')
          });
        }

        if (param.field.name === 'SHIRINA-SPALNOGO-MESTA') {
          sleepingSize.push({
            label: t('params.param_9'),
            text: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm')
          });
        }
      });
    }

    return {
      brand,
      size,
      sleepingSize
    };
  }, [product]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Brand_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Top, {
      children: ((_dataList$brand = dataList.brand) !== null && _dataList$brand !== void 0 ? _dataList$brand : []).map(({
        text,
        to,
        label
      }, index) => {
        if (to) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(Brand_Item, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Brand_Label, {
              children: [label, ": "]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: to,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Text, {
                hasColor: true,
                children: text
              })
            })]
          }, index);
        }

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Brand_Item, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Brand_Label, {
            children: [label, ": "]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Text, {
            children: text
          })]
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Middle, {
      children: [!!(product === null || product === void 0 ? void 0 : product.size).length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextWithIcon_TextWithIcon, {
          note: t('params.param_3'),
          icon: "size",
          fontWeight: 600,
          marginTop: 10
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemWrapper, {
          children: dataList.size.map(({
            text,
            label
          }, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(ItemColumn, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Label, {
              children: label
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Text, {
              children: text
            })]
          }, index))
        })]
      }) : null, !!(product === null || product === void 0 ? void 0 : product.matressSize).length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextWithIcon_TextWithIcon, {
          note: t('params.param_2'),
          icon: "size",
          fontWeight: 600,
          marginTop: 10
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ItemWrapper, {
          children: dataList.sleepingSize.map(({
            text,
            label
          }, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(ItemColumn, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Label, {
              children: label
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Text, {
              children: text
            })]
          }, index))
        })]
      }) : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Bottom, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Material_Material, {})
    })]
  });
}

/* harmony default export */ var Brand_Brand = (Brand);
const Brand_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__Component",
  componentId: "sc-1rajq1m-0"
})(["margin-top:20px;"]);
const Top = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__Top",
  componentId: "sc-1rajq1m-1"
})(["& > div:not(:first-child){margin-top:5px;}"]);
const Brand_Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__Item",
  componentId: "sc-1rajq1m-2"
})([""]);
const ItemColumn = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__ItemColumn",
  componentId: "sc-1rajq1m-3"
})(["display:flex;flex-direction:column;flex:1;"]);
const ItemWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__ItemWrapper",
  componentId: "sc-1rajq1m-4"
})(["margin-top:7px;max-width:480px;display:flex;"]);
const Brand_Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Brand__Label",
  componentId: "sc-1rajq1m-5"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:20px;color:", ";"], theme/* colors.gray400 */.O9.gray400);
const Brand_Text = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Brand__Text",
  componentId: "sc-1rajq1m-6"
})(["font-style:normal;font-weight:normal;font-size:12px;", ";"], ({
  hasColor
}) => hasColor ? (0,styled_components_browser_esm.css)(["color:", ";font-weight:600;"], theme/* colors.primary */.O9.primary) : (0,styled_components_browser_esm.css)(["", ""], theme/* colors.black */.O9.black));
const Middle = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__Middle",
  componentId: "sc-1rajq1m-7"
})([""]);
const Brand_Bottom = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Brand__Bottom",
  componentId: "sc-1rajq1m-8"
})(["margin-top:15px;button{margin:0 auto;}"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Brand/index.ts

;// CONCATENATED MODULE: ./src/assets/svg/sofa_length.svg
function sofa_length_extends() { sofa_length_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sofa_length_extends.apply(this, arguments); }



var sofa_length_ref = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#clip0_1_1247)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 30H30V29H26V30ZM5 18.2V20H27V18.2C27 16.8 27.8 15.6 29 15.2V10.8C29 9.80002 28.2 8.90002 27.1 8.90002H4.9C3.8 9.00002 3 9.80002 3 10.9V15.3C4.2 15.6 5 16.8 5 18.2ZM5 23H27V21H5V23ZM2 30H6V29H2V30ZM31.4 16.3C31 15.9 30.5 15.7 30 15.7C29.5 15.7 29 15.9 28.6 16.3C28.2 16.7 28 17.2 28 17.7V23.5C28 23.8 27.8 24.1 27.4 24.1H4.6C4.3 24 4 23.7 4 23.4V17.7C4 17 3.6 16.3 3 16C1.5 15.3 0 16.3 0 17.7V28H32V17.7C32 17.2 31.8 16.7 31.4 16.3Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/react.createElement("path", {
  d: "M34 4H4V6H34V4Z",
  fill: "#860935"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.7 4.2L31.8 0.3C31.4 -0.1 30.7 -0.1 30.3 0.3C29.9 0.7 29.9 1.4 30.3 1.8L33.4 5L30.3 8.2C29.9 8.6 29.9 9.3 30.3 9.7C30.5 9.9 30.8 10 31.1 10C31.4 10 31.7 9.9 31.9 9.7L35.8 5.8C36.1 5.3 36.1 4.7 35.7 4.2Z",
  fill: "#860935"
}));

var sofa_length_ref2 = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "clip0_1_1247"
}, /*#__PURE__*/react.createElement("rect", {
  width: 36,
  height: 30,
  fill: "white"
})));

function SvgSofaLength({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", sofa_length_extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sofa_length_ref, sofa_length_ref2);
}

/* harmony default export */ var sofa_length = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzNiAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTI0NykiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTI2IDMwSDMwVjI5SDI2VjMwWk01IDE4LjJWMjBIMjdWMTguMkMyNyAxNi44IDI3LjggMTUuNiAyOSAxNS4yVjEwLjhDMjkgOS44MDAwMiAyOC4yIDguOTAwMDIgMjcuMSA4LjkwMDAySDQuOUMzLjggOS4wMDAwMiAzIDkuODAwMDIgMyAxMC45VjE1LjNDNC4yIDE1LjYgNSAxNi44IDUgMTguMlpNNSAyM0gyN1YyMUg1VjIzWk0yIDMwSDZWMjlIMlYzMFpNMzEuNCAxNi4zQzMxIDE1LjkgMzAuNSAxNS43IDMwIDE1LjdDMjkuNSAxNS43IDI5IDE1LjkgMjguNiAxNi4zQzI4LjIgMTYuNyAyOCAxNy4yIDI4IDE3LjdWMjMuNUMyOCAyMy44IDI3LjggMjQuMSAyNy40IDI0LjFINC42QzQuMyAyNCA0IDIzLjcgNCAyMy40VjE3LjdDNCAxNyAzLjYgMTYuMyAzIDE2QzEuNSAxNS4zIDAgMTYuMyAwIDE3LjdWMjhIMzJWMTcuN0MzMiAxNy4yIDMxLjggMTYuNyAzMS40IDE2LjNaIiBmaWxsPSIjQjNCM0IzIi8+CjxwYXRoIGQ9Ik0zNCA0SDRWNkgzNFY0WiIgZmlsbD0iIzg2MDkzNSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTM1LjcgNC4yTDMxLjggMC4zQzMxLjQgLTAuMSAzMC43IC0wLjEgMzAuMyAwLjNDMjkuOSAwLjcgMjkuOSAxLjQgMzAuMyAxLjhMMzMuNCA1TDMwLjMgOC4yQzI5LjkgOC42IDI5LjkgOS4zIDMwLjMgOS43QzMwLjUgOS45IDMwLjggMTAgMzEuMSAxMEMzMS40IDEwIDMxLjcgOS45IDMxLjkgOS43TDM1LjggNS44QzM2LjEgNS4zIDM2LjEgNC43IDM1LjcgNC4yWiIgZmlsbD0iIzg2MDkzNSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTI0NyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/sofa_width.svg
function sofa_width_extends() { sofa_width_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sofa_width_extends.apply(this, arguments); }



var sofa_width_ref = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#clip0_1_1224)"
}, /*#__PURE__*/react.createElement("path", {
  d: "M33 4H11V6H33V4Z",
  fill: "#860935"
}), /*#__PURE__*/react.createElement("path", {
  d: "M34.7 4.2L30.8 0.3C30.4 -0.1 29.7 -0.1 29.3 0.3C28.9 0.7 28.9 1.4 29.3 1.8L32.4 5L29.3 8.2C28.9 8.6 28.9 9.3 29.3 9.7C29.5 9.9 29.8 10 30.1 10C30.4 10 30.7 9.9 30.9 9.7L34.8 5.8C35.1 5.3 35.1 4.7 34.7 4.2Z",
  fill: "#860935"
}), /*#__PURE__*/react.createElement("path", {
  d: "M5.2 8H7V5C7 3.3 5.7 2 4 2C2.3 2 1 3.3 1 5V10C1 10.1 1 10.2 1 10.2C1.9 8.9 3.4 8 5.2 8Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/react.createElement("path", {
  d: "M30.5 16H29.9V25H30.5C31.3 25 32 24.3 32 23.5V17.5C32 16.7 31.3 16 30.5 16Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/react.createElement("path", {
  d: "M3.99995 13C2.89995 13 1.99995 12.5 1.49995 11.6C1.29995 12 1.19995 12.5 1.19995 13V25H28.5C27.7 25 27 24.3 27 23.5V17.5C27 16.7 27.7 16 28.5 16H28.7999V13C28.7999 10.8 27 9 24.7999 9H6.99995V10C6.99995 11.7 5.69995 13 3.99995 13Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/react.createElement("path", {
  d: "M1.5 11.6C2 12.5 2.9 13 4 13C5.7 13 7 11.7 7 10V9H5.2C3.5 9 2 10.1 1.5 11.6Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/react.createElement("path", {
  d: "M27 17.5V23.5C27 24.3 27.7 25 28.5 25H28.8V16H28.5C27.7 16 27 16.7 27 17.5Z",
  fill: "#B3B3B3"
}));

var sofa_width_ref2 = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "clip0_1_1224"
}, /*#__PURE__*/react.createElement("rect", {
  width: 35,
  height: 26,
  fill: "white"
})));

function SvgSofaWidth({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", sofa_width_extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sofa_width_ref, sofa_width_ref2);
}

/* harmony default export */ var sofa_width = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzNSAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTIyNCkiPgo8cGF0aCBkPSJNMzMgNEgxMVY2SDMzVjRaIiBmaWxsPSIjODYwOTM1Ii8+CjxwYXRoIGQ9Ik0zNC43IDQuMkwzMC44IDAuM0MzMC40IC0wLjEgMjkuNyAtMC4xIDI5LjMgMC4zQzI4LjkgMC43IDI4LjkgMS40IDI5LjMgMS44TDMyLjQgNUwyOS4zIDguMkMyOC45IDguNiAyOC45IDkuMyAyOS4zIDkuN0MyOS41IDkuOSAyOS44IDEwIDMwLjEgMTBDMzAuNCAxMCAzMC43IDkuOSAzMC45IDkuN0wzNC44IDUuOEMzNS4xIDUuMyAzNS4xIDQuNyAzNC43IDQuMloiIGZpbGw9IiM4NjA5MzUiLz4KPHBhdGggZD0iTTUuMiA4SDdWNUM3IDMuMyA1LjcgMiA0IDJDMi4zIDIgMSAzLjMgMSA1VjEwQzEgMTAuMSAxIDEwLjIgMSAxMC4yQzEuOSA4LjkgMy40IDggNS4yIDhaIiBmaWxsPSIjQjNCM0IzIi8+CjxwYXRoIGQ9Ik0zMC41IDE2SDI5LjlWMjVIMzAuNUMzMS4zIDI1IDMyIDI0LjMgMzIgMjMuNVYxNy41QzMyIDE2LjcgMzEuMyAxNiAzMC41IDE2WiIgZmlsbD0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNMy45OTk5NSAxM0MyLjg5OTk1IDEzIDEuOTk5OTUgMTIuNSAxLjQ5OTk1IDExLjZDMS4yOTk5NSAxMiAxLjE5OTk1IDEyLjUgMS4xOTk5NSAxM1YyNUgyOC41QzI3LjcgMjUgMjcgMjQuMyAyNyAyMy41VjE3LjVDMjcgMTYuNyAyNy43IDE2IDI4LjUgMTZIMjguNzk5OVYxM0MyOC43OTk5IDEwLjggMjcgOSAyNC43OTk5IDlINi45OTk5NVYxMEM2Ljk5OTk1IDExLjcgNS42OTk5NSAxMyAzLjk5OTk1IDEzWiIgZmlsbD0iI0IzQjNCMyIvPgo8cGF0aCBkPSJNMS41IDExLjZDMiAxMi41IDIuOSAxMyA0IDEzQzUuNyAxMyA3IDExLjcgNyAxMFY5SDUuMkMzLjUgOSAyIDEwLjEgMS41IDExLjZaIiBmaWxsPSIjQjNCM0IzIi8+CjxwYXRoIGQ9Ik0yNyAxNy41VjIzLjVDMjcgMjQuMyAyNy43IDI1IDI4LjUgMjVIMjguOFYxNkgyOC41QzI3LjcgMTYgMjcgMTYuNyAyNyAxNy41WiIgZmlsbD0iI0IzQjNCMyIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTIyNCI+CjxyZWN0IHdpZHRoPSIzNSIgaGVpZ2h0PSIyNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K");

;// CONCATENATED MODULE: ./src/assets/svg/sofa_heigth.svg
function sofa_heigth_extends() { sofa_heigth_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sofa_heigth_extends.apply(this, arguments); }



var sofa_heigth_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36 25H40V24H36V25ZM15 13.2V15H37V13.2C37 11.8 37.8 10.6 39 10.2V5.9C39 4.9 38.2 4 37.1 4H14.9C13.9 4 13 4.8 13 5.9V10.3C14.2 10.6 15 11.8 15 13.2ZM15 18H37V16H15V18ZM12 25H16V24H12V25ZM41.4 11.3C41 10.9 40.5 10.7 40 10.7C39.5 10.7 39 10.9 38.6 11.3C38.2 11.7 38 12.2 38 12.7V18.5C38 18.8 37.8 19.1 37.4 19.1H14.6C14.3 19.1 14 18.8 14 18.5V12.8C14 12.1 13.6 11.4 13 11.1C11.5 10.4 10 11.4 10 12.8V23H42V12.7C42 12.2 41.8 11.7 41.4 11.3Z",
  fill: "#B3B3B3"
});

var sofa_heigth_ref2 = /*#__PURE__*/react.createElement("path", {
  d: "M6 2H4V25H6V2Z",
  fill: "#860935"
});

var _ref3 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.7 4.2L5.8 0.3C5.4 -0.1 4.7 -0.1 4.3 0.3L0.3 4.2C0.1 4.4 0 4.7 0 4.9C0 5.2 0.1 5.4 0.3 5.7C0.7 6.1 1.4 6.1 1.8 5.7L5 2.6L8.2 5.7C8.6 6.1 9.3 6.1 9.7 5.7C10.1 5.3 10.1 4.6 9.7 4.2Z",
  fill: "#860935"
});

function SvgSofaHeigth({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", sofa_heigth_extends({
    width: 42,
    height: 25,
    viewBox: "0 0 42 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, sofa_heigth_ref, sofa_heigth_ref2, _ref3);
}

/* harmony default export */ var sofa_heigth = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCA0MiAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zNiAyNUg0MFYyNEgzNlYyNVpNMTUgMTMuMlYxNUgzN1YxMy4yQzM3IDExLjggMzcuOCAxMC42IDM5IDEwLjJWNS45QzM5IDQuOSAzOC4yIDQgMzcuMSA0SDE0LjlDMTMuOSA0IDEzIDQuOCAxMyA1LjlWMTAuM0MxNC4yIDEwLjYgMTUgMTEuOCAxNSAxMy4yWk0xNSAxOEgzN1YxNkgxNVYxOFpNMTIgMjVIMTZWMjRIMTJWMjVaTTQxLjQgMTEuM0M0MSAxMC45IDQwLjUgMTAuNyA0MCAxMC43QzM5LjUgMTAuNyAzOSAxMC45IDM4LjYgMTEuM0MzOC4yIDExLjcgMzggMTIuMiAzOCAxMi43VjE4LjVDMzggMTguOCAzNy44IDE5LjEgMzcuNCAxOS4xSDE0LjZDMTQuMyAxOS4xIDE0IDE4LjggMTQgMTguNVYxMi44QzE0IDEyLjEgMTMuNiAxMS40IDEzIDExLjFDMTEuNSAxMC40IDEwIDExLjQgMTAgMTIuOFYyM0g0MlYxMi43QzQyIDEyLjIgNDEuOCAxMS43IDQxLjQgMTEuM1oiIGZpbGw9IiNCM0IzQjMiLz4KPHBhdGggZD0iTTYgMkg0VjI1SDZWMloiIGZpbGw9IiM4NjA5MzUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05LjcgNC4yTDUuOCAwLjNDNS40IC0wLjEgNC43IC0wLjEgNC4zIDAuM0wwLjMgNC4yQzAuMSA0LjQgMCA0LjcgMCA0LjlDMCA1LjIgMC4xIDUuNCAwLjMgNS43QzAuNyA2LjEgMS40IDYuMSAxLjggNS43TDUgMi42TDguMiA1LjdDOC42IDYuMSA5LjMgNi4xIDkuNyA1LjdDMTAuMSA1LjMgMTAuMSA0LjYgOS43IDQuMloiIGZpbGw9IiM4NjA5MzUiLz4KPC9zdmc+Cg==");

;// CONCATENATED MODULE: ./src/assets/svg/mattress_length.svg
function mattress_length_extends() { mattress_length_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mattress_length_extends.apply(this, arguments); }



var mattress_length_ref = /*#__PURE__*/react.createElement("g", {
  clipPath: "url(#clip0_1_1257)"
}, /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27 10H5C2.2 10 0 12.2 0 15V27C0 29.8 2.2 32 5 32H27C29.8 32 32 29.8 32 27V15C32 12.2 29.8 10 27 10Z",
  fill: "#B3B3B3"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 15H7C6.4 15 6 15.4 6 16C6 16.6 6.4 17 7 17H11C11.6 17 12 16.6 12 16C12 15.4 11.6 15 11 15Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 20H7C6.4 20 6 20.4 6 21C6 21.6 6.4 22 7 22H11C11.6 22 12 21.6 12 21C12 20.4 11.6 20 11 20Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 25H7C6.4 25 6 25.4 6 26C6 26.6 6.4 27 7 27H11C11.6 27 12 26.6 12 26C12 25.4 11.6 25 11 25Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 15H16C15.4 15 15 15.4 15 16C15 16.6 15.4 17 16 17H20C20.6 17 21 16.6 21 16C21 15.4 20.6 15 20 15Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 20H16C15.4 20 15 20.4 15 21C15 21.6 15.4 22 16 22H20C20.6 22 21 21.6 21 21C21 20.4 20.6 20 20 20Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 25H16C15.4 25 15 25.4 15 26C15 26.6 15.4 27 16 27H20C20.6 27 21 26.6 21 26C21 25.4 20.6 25 20 25Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26 14C25.4 14 25 14.4 25 15V27C25 27.6 25.4 28 26 28C26.6 28 27 27.6 27 27V15C27 14.4 26.6 14 26 14Z",
  fill: "white"
}), /*#__PURE__*/react.createElement("path", {
  d: "M35 4H0V6H35V4Z",
  fill: "#860935"
}), /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.7 4.2L32.8 0.3C32.6 0.1 32.3 0 32.1 0C31.8 0 31.6 0.1 31.3 0.3C30.9 0.7 30.9 1.4 31.3 1.8L34.4 5L31.3 8.2C30.9 8.6 30.9 9.3 31.3 9.7C31.7 10.1 32.4 10.1 32.8 9.7L36.7 5.8C37.1 5.3 37.1 4.7 36.7 4.2Z",
  fill: "#860935"
}));

var mattress_length_ref2 = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
  id: "clip0_1_1257"
}, /*#__PURE__*/react.createElement("rect", {
  width: 37,
  height: 32,
  fill: "white"
})));

function SvgMattressLength({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", mattress_length_extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, mattress_length_ref, mattress_length_ref2);
}

/* harmony default export */ var mattress_length = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/assets/svg/mattress_width.svg
function mattress_width_extends() { mattress_width_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return mattress_width_extends.apply(this, arguments); }



var mattress_width_ref = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39 3H17C14.2 3 12 5.2 12 8V20C12 22.8 14.2 25 17 25H39C41.8 25 44 22.8 44 20V8C44 5.2 41.8 3 39 3Z",
  fill: "#B3B3B3"
});

var mattress_width_ref2 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 8H19C18.4 8 18 8.4 18 9C18 9.6 18.4 10 19 10H23C23.6 10 24 9.6 24 9C24 8.4 23.6 8 23 8Z",
  fill: "white"
});

var mattress_width_ref3 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 13H19C18.4 13 18 13.4 18 14C18 14.6 18.4 15 19 15H23C23.6 15 24 14.6 24 14C24 13.4 23.6 13 23 13Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23 18H19C18.4 18 18 18.4 18 19C18 19.6 18.4 20 19 20H23C23.6 20 24 19.6 24 19C24 18.4 23.6 18 23 18Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 8H28C27.4 8 27 8.4 27 9C27 9.6 27.4 10 28 10H32C32.6 10 33 9.6 33 9C33 8.4 32.6 8 32 8Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 13H28C27.4 13 27 13.4 27 14C27 14.6 27.4 15 28 15H32C32.6 15 33 14.6 33 14C33 13.4 32.6 13 32 13Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32 18H28C27.4 18 27 18.4 27 19C27 19.6 27.4 20 28 20H32C32.6 20 33 19.6 33 19C33 18.4 32.6 18 32 18Z",
  fill: "white"
});

var _ref8 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38 7C37.4 7 37 7.4 37 8V20C37 20.6 37.4 21 38 21C38.6 21 39 20.6 39 20V8C39 7.4 38.6 7 38 7Z",
  fill: "white"
});

var _ref9 = /*#__PURE__*/react.createElement("path", {
  d: "M6 2H4V25H6V2Z",
  fill: "#860935"
});

var _ref10 = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.7 4.2L5.8 0.3C5.4 -0.1 4.7 -0.1 4.3 0.3L0.3 4.2C0.1 4.4 0 4.7 0 4.9C0 5.2 0.1 5.4 0.3 5.7C0.7 6.1 1.4 6.1 1.8 5.7L5 2.6L8.2 5.7C8.6 6.1 9.3 6.1 9.7 5.7C10.1 5.3 10.1 4.6 9.7 4.2Z",
  fill: "#860935"
});

function SvgMattressWidth({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/react.createElement("svg", mattress_width_extends({
    width: 44,
    height: 25,
    viewBox: "0 0 44 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, mattress_width_ref, mattress_width_ref2, mattress_width_ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

/* harmony default export */ var mattress_width = ("data:image/svg+xml;base64,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");

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/components/Params/Params.tsx

















var SizeMejanizm;

(function (SizeMejanizm) {
  SizeMejanizm["SIZE"] = "size";
  SizeMejanizm["SLEEPING_SIZE"] = "sleeping-size";
  SizeMejanizm["DLINA"] = "DLINA";
  SizeMejanizm["VYSOTA"] = "VYSOTA";
  SizeMejanizm["GLUBINA"] = "GLUBINA";
  SizeMejanizm["DLINA_SPALNOGO_MESTA"] = "DLINA-SPALNOGO-MESTA";
  SizeMejanizm["SHIRINA_SPALNOGO_MESTA"] = "SHIRINA-SPALNOGO-MESTA";
  SizeMejanizm["MEHANIZMY"] = "MEHANIZM-TRANSFORMACII";
  SizeMejanizm["KOMPLEKTACIYA"] = "KOMPLEKTACIYA";
})(SizeMejanizm || (SizeMejanizm = {}));

function getIconSize(type) {
  switch (type) {
    case SizeMejanizm.DLINA:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SvgSofaLength, {});

    case SizeMejanizm.VYSOTA:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SvgSofaHeigth, {});

    case SizeMejanizm.GLUBINA:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SvgSofaWidth, {});

    case SizeMejanizm.DLINA_SPALNOGO_MESTA:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SvgMattressLength, {});

    case SizeMejanizm.SHIRINA_SPALNOGO_MESTA:
      return /*#__PURE__*/(0,jsx_runtime.jsx)(SvgMattressWidth, {});

    default:
      return null;
  }
}

function getSizeMehanizmData(data, size, matress) {
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [data.map(({
      label,
      value,
      to,
      category
    }, index) => {
      if (category === SizeMejanizm.MEHANIZMY) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(MehanizmWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
            children: label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
            children: value
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
            to: to,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(MehanizmButton, {
              children: t('mechanism_more')
            })
          })]
        }, index);
      }
    }), size ? /*#__PURE__*/(0,jsx_runtime.jsxs)(SizeWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
        children: 'params.param_3'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SizeContent, {
        children: data.map(({
          type,
          label,
          value,
          to,
          category
        }, index) => {
          if (category === SizeMejanizm.SIZE) {
            if (type === SizeMejanizm.DLINA || type === SizeMejanizm.VYSOTA || type === SizeMejanizm.GLUBINA) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
                isFlex: true,
                className: "size-wrapper__param",
                children: [getIconSize(type), /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrapper, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
                    isGray: true,
                    size: 11,
                    children: label
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
                    children: value
                  })]
                })]
              }, index);
            }
          }
        })
      })]
    }) : null, matress ? /*#__PURE__*/(0,jsx_runtime.jsxs)(SizeWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
        children: 'params.param_2'
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SizeContent, {
        children: data.map(({
          type,
          label,
          value,
          to,
          category
        }, index) => {
          if (category === SizeMejanizm.SLEEPING_SIZE) {
            if (type === SizeMejanizm.DLINA_SPALNOGO_MESTA || type === SizeMejanizm.SHIRINA_SPALNOGO_MESTA) {
              return /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
                isFlex: true,
                children: [getIconSize(type), /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionWrapper, {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
                    isGray: true,
                    size: 11,
                    children: label
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
                    children: value
                  })]
                })]
              }, index);
            }
          }
        })
      })]
    }) : null]
  });
}

function getRestParams(data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: data.map(({
      type,
      label,
      value,
      to,
      category,
      multiple
    }, index) => {
      if (type === 'SELECT' && category !== SizeMejanizm.MEHANIZMY) {
        var _label;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
            isGray: true,
            children: label
          }), multiple && Array.isArray(value) ? value.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
            children: item.label
          }, index)) : /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
            children: (_label = value === null || value === void 0 ? void 0 : value.label) !== null && _label !== void 0 ? _label : value
          }, index)]
        }, index);
      }

      if (type === 'NUMBER' && category !== SizeMejanizm.MEHANIZMY) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
            isGray: true,
            children: label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
            children: value
          })]
        }, index);
      }

      if (type === 'TRUE_FALSE' && category !== SizeMejanizm.MEHANIZMY) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
            isGray: true,
            children: label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
            children: value
          })]
        }, index);
      }

      if (type === 'STRING') {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(Param, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Params_Label, {
            isGray: true,
            children: label
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Params_Note, {
            children: value
          })]
        }, index);
      }
    })
  });
}

function Params({
  data,
  setHeight
}) {
  const router = (0,next_router.useRouter)();
  const alias = (0,common/* getAliasString */.Jz)(router.query.alias);
  const {
    data: product
  } = (0,store/* useTypedSelector */.ix)(state => (0,product_product/* selectProductResource */.jN)(state, alias));
  const hasSize = !!(product === null || product === void 0 ? void 0 : product.size).length;
  const hasMatressSize = !!(product === null || product === void 0 ? void 0 : product.matressSize).length;
  const ref = (0,react.useRef)(null);
  (0,react.useLayoutEffect)(() => {
    if (ref.current) {
      setHeight === null || setHeight === void 0 ? void 0 : setHeight(ref.current.scrollHeight);
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Params_Component, {
    ref: ref,
    children: [getSizeMehanizmData(data, hasSize, hasMatressSize), getRestParams(data)]
  });
}

/* harmony default export */ var Params_Params = (Params);
const Params_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__Component",
  componentId: "sc-8ojzck-0"
})(["max-width:480px;padding-bottom:20px;& > *:first-child{margin-top:0;}"]);
const MehanizmWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__MehanizmWrapper",
  componentId: "sc-8ojzck-1"
})([""]);
const SizeWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__SizeWrapper",
  componentId: "sc-8ojzck-2"
})(["margin-top:20px;"]);
const SizeContent = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__SizeContent",
  componentId: "sc-8ojzck-3"
})(["margin-top:5px;display:flex;justify-content:space-between;.size-wrapper__param{margin-top:0;}& > div{margin-top:0;}"]);
const MehanizmButton = styled_components_browser_esm["default"].button.withConfig({
  displayName: "Params__MehanizmButton",
  componentId: "sc-8ojzck-4"
})(["font-style:normal;font-weight:600;font-size:13px;line-height:18px;cursor:pointer;color:", ";"], theme/* colors.primary */.O9.primary);
const Param = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__Param",
  componentId: "sc-8ojzck-5"
})(["margin-top:20px;flex:1;", ""], ({
  isFlex
}) => isFlex ? (0,styled_components_browser_esm.css)(["display:flex;align-items:center;"]) : null);
const DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__DescriptionWrapper",
  componentId: "sc-8ojzck-6"
})(["margin-left:5px;"]);
const Params_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__Label",
  componentId: "sc-8ojzck-7"
})(["font-style:normal;line-height:18px;", " ", ""], ({
  isGray
}) => isGray ? (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.gray400 */.O9.gray400) : (0,styled_components_browser_esm.css)(["color:", ";"], theme/* colors.black */.O9.black), ({
  size
}) => size ? (0,styled_components_browser_esm.css)(["font-size:", "px;font-weight:normal;"], size) : (0,styled_components_browser_esm.css)(["font-size:13px;font-weight:600;"]));
const Params_Note = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Params__Note",
  componentId: "sc-8ojzck-8"
})(["margin-top:2px;font-style:normal;font-weight:normal;font-size:13px;line-height:18px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/components/Params/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/components/Description/Description.tsx





function Description_Description({
  data,
  setHeight
}) {
  const ref = (0,react.useRef)(null);
  (0,react.useLayoutEffect)(() => {
    if (ref.current) {
      setHeight === null || setHeight === void 0 ? void 0 : setHeight(ref.current.scrollHeight);
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Component, {
    ref: ref,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Content, {
      children: data.map((content, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Description_Content, {
        dangerouslySetInnerHTML: {
          __html: content.content
        }
      }, index))
    })
  });
}

/* harmony default export */ var components_Description_Description = (Description_Description);
const Description_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Component",
  componentId: "sc-1pam5zz-0"
})(["& > *:first-child{margin-top:0;}"]);
const Description_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Description__Content",
  componentId: "sc-1pam5zz-1"
})(["padding-bottom:15px;& > p,ul{margin-top:20px;}& > ul li{list-style:initial;margin-left:15px;}& > *:first-child{margin-top:0;}& > ul a{color:", ";}"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/components/Description/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/components/Schema/Schema.tsx


function Schema_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Schema_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Schema_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Schema_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function Schema({
  data,
  setHeight
}) {
  const ref = (0,react.useRef)(null);
  (0,react.useLayoutEffect)(() => {
    if (ref.current) {
      setHeight(ref.current.scrollHeight);
    }
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Schema_Component, {
    ref: ref,
    children: data.map((schema, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Schema_Content, {
      className: "schema-content",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Schema_Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Picture/* default */.Z, Schema_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureImage */.iS)(schema.original)))
      })
    }, index))
  });
}

/* harmony default export */ var Schema_Schema = (Schema);
const Schema_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Schema__Component",
  componentId: "sc-6oafd3-0"
})(["height:100%;& > .schema-content:first-child{margin-top:0;}"]);
const Schema_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Schema__Content",
  componentId: "sc-6oafd3-1"
})(["padding:15px 0;"]);
const Schema_Item = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Schema__Item",
  componentId: "sc-6oafd3-2"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/components/Schema/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/helpres.ts



const getChildNode = type => {
  return type === 'params' ? Params_Params : type === 'description' ? components_Description_Description : type === 'schema' ? Schema_Schema : null;
};
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/Collapse.tsx









function Collapse_Collapse({
  data,
  type,
  label
}) {
  const {
    0: isOpen,
    1: setOpen
  } = (0,react.useState)((0,common/* getCurrentProject */.vo)() === 'dveri');
  const {
    0: height,
    1: setHeight
  } = (0,react.useState)(0);
  const ref = (0,react.useRef)(null);

  const clickHandler = () => {
    setOpen(prev => !prev);
  };

  const Child = getChildNode(type);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Tab, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Collapse_Header, {
      className: "params-collapse-header",
      active: isOpen,
      onClick: clickHandler,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Collapse_Label, {
        children: label
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Collapse_StyledIcon, {})]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CollapseWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Children, {
        ref: ref,
        active: isOpen,
        size: height,
        children: Child ? /*#__PURE__*/(0,jsx_runtime.jsx)(Child, {
          data: data,
          setHeight: setHeight
        }) : null
      })
    })]
  });
}

/* harmony default export */ var components_Collapse_Collapse = (Collapse_Collapse);
const Tab = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__Tab",
  componentId: "sc-woywgc-0"
})([""]);
const Collapse_Label = styled_components_browser_esm["default"].span.withConfig({
  displayName: "Collapse__Label",
  componentId: "sc-woywgc-1"
})(["width:75%;font-style:normal;font-weight:500;font-size:12px;line-height:20px;"]);
const Collapse_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__Header",
  componentId: "sc-woywgc-2"
})(["padding:10px 15px;cursor:pointer;display:flex;align-items:center;justify-content:space-between;& > svg{transition:transform 0.2s ease;}", ""], ({
  active
}) => active && (0,styled_components_browser_esm.css)(["& > span{color:", ";}& > svg{transform:rotate(-180deg);}& > svg path{fill:", ";}background:", ";border-bottom:1px solid ", ";"], theme/* colors.primary */.O9.primary, theme/* colors.primary */.O9.primary, theme/* colors.gray50 */.O9.gray50, theme/* colors.gray70 */.O9.gray70));
const CollapseWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__CollapseWrapper",
  componentId: "sc-woywgc-3"
})(["overflow:hidden;padding:0 15px;"]);
const Children = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Collapse__Children",
  componentId: "sc-woywgc-4"
})(["transition:height 0.2s ease,margin 0.2s ease;", ""], ({
  active,
  size
}) => active ? (0,styled_components_browser_esm.css)(["height:", "px;margin-top:9px;"], size) : (0,styled_components_browser_esm.css)(["height:0;margin-top:0;"]));
const Collapse_StyledIcon = (0,styled_components_browser_esm["default"])(arrow_question/* ReactComponent */.r).withConfig({
  displayName: "Collapse__StyledIcon",
  componentId: "sc-woywgc-5"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/components/Collapse/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/Tabs.tsx


function Tabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Tabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Tabs_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Tabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










function getMatressSizeLabel(t, type) {
  switch (type) {
    case 'DLINA-SPALNOGO-MESTA':
      return t('params.param_6');

    case 'SHIRINA-SPALNOGO-MESTA':
      return t('params.param_9');

    default:
      return '';
  }
}

function Tabs({
  product
}) {
  const t = (0,production/* useTranslations */.T_)();
  const dataList = (0,react.useMemo)(() => {
    let params = [];
    const description = [];
    const schema = [];

    if (product !== null && product !== void 0 && product.params) {
      product.params.forEach((param, index) => {
        if (param.field.name === 'MEHANIZM-TRANSFORMACII') {
          var _param$value;

          params.push({
            label: param.field.label,
            value: (_param$value = param.value) === null || _param$value === void 0 ? void 0 : _param$value.label,
            to: '/blog/mehanizmy-razlojeniya-divanov/',
            category: param.field.name,
            type: param.field.type
          });
        }

        if (param.field.name === 'DLINA' || param.field.name === 'VYSOTA' || param.field.name === 'GLUBINA') {
          params.push({
            label: param.field.label,
            value: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm'),
            category: 'size',
            type: param.field.name
          });
        }

        if (param.field.name === 'DLINA-SPALNOGO-MESTA' || param.field.name === 'SHIRINA-SPALNOGO-MESTA') {
          params.push({
            label: getMatressSizeLabel(t, param.field.name),
            value: Math.ceil(param.value / 10) + ' ' + t('dimensions.sm'),
            category: 'sleeping-size',
            type: param.field.name
          });
        }

        if (param.field.type === 'NUMBER' && param.field.name !== 'DLINA' && param.field.name !== 'GLUBINA' && param.field.name !== 'VYSOTA' && param.field.name !== 'DLINA-SPALNOGO-MESTA' && param.field.name !== 'SHIRINA-SPALNOGO-MESTA') {
          params.push({
            label: param.field.label,
            value: param.value,
            type: param.field.type
          });
        }

        if (param.field.type === 'SELECT' && param.field.name !== 'MEHANIZM-TRANSFORMACII' && param.field.name !== 'KOMPLEKTACIYA') {
          params.push({
            label: param.field.label,
            value: param.field.multiple ? param.value : param.value !== null ? param.value : t('dimensions.no'),
            multiple: param.field.multiple,
            type: param.field.type
          });
        }

        if (param.field.type === 'TRUE_FALSE') {
          params.push({
            type: param.field.type,
            label: param.field.label,
            value: param.value ? t('dimensions.yes') : t('dimensions.no')
          });
        }
      });
    }

    if ((0,common/* getCurrentProject */.vo)() === 'dveri') {
      product === null || product === void 0 ? void 0 : product.params.forEach(productParam => {
        params.push({
          type: "STRING",
          label: productParam.field.label.toString(),
          value: productParam.value ? productParam.value.toString() : ''
        });
      });
    }

    console.log(params);

    if (product !== null && product !== void 0 && product.content) {
      description.push({
        content: product.content
      });
    }

    if (product !== null && product !== void 0 && product.schemaImage) {
      schema.push({
        original: product.schemaImage.original,
        preview: product.schemaImage.preview
      });
    }

    return [{
      type: 'params',
      label: t('product.tab_params'),
      data: params
    }, {
      type: 'description',
      label: t('product.tab_description'),
      data: description
    }, {
      type: 'schema',
      label: t('product.tab_schema'),
      data: schema
    }];
  }, [product]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_Component, {
    children: dataList.map((list, index) => {
      return !!list.data.length ? /*#__PURE__*/(0,react.createElement)(components_Collapse_Collapse, Tabs_objectSpread(Tabs_objectSpread({}, list), {}, {
        key: index
      })) : null;
    })
  });
}

/* harmony default export */ var Tabs_Tabs = (Tabs);
const Tabs_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Tabs__Component",
  componentId: "sc-2kwm9z-0"
})(["margin-top:24px;& > div .params-collapse-header{border-top:1px solid ", ";}& > div:last-child .params-collapse-header{border-bottom:1px solid ", ";}"], theme/* colors.gray70 */.O9.gray70, theme/* colors.gray70 */.O9.gray70);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Tabs/index.ts

;// CONCATENATED MODULE: ./src/components/Button/DiscountButton.tsx


const DiscountButton_excluded = ["onClick", "discount", "children"];

function DiscountButton_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function DiscountButton_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { DiscountButton_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { DiscountButton_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function DiscountButton(_ref) {
  let {
    onClick,
    discount,
    children
  } = _ref,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, DiscountButton_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Co, DiscountButton_objectSpread(DiscountButton_objectSpread({
    onClick: onClick
  }, rest), {}, {
    variant: "contained-primary-w100",
    children: children
  }));
}

/* harmony default export */ var Button_DiscountButton = (DiscountButton);
const Discount = styled_components_browser_esm["default"].div.withConfig({
  displayName: "DiscountButton__Discount",
  componentId: "sc-1hcc79u-0"
})(["font-style:normal;font-weight:600;font-size:22px;line-height:20px;color:", ";position:absolute;top:50%;transform:translateY(-50%);right:10px;"], theme/* colors.white */.O9.white);
// EXTERNAL MODULE: ./src/components/Forms/SuccessForm.tsx + 1 modules
var SuccessForm = __webpack_require__(29117);
;// CONCATENATED MODULE: ./src/components/OrderCard/OrderCard.tsx


function OrderCard_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function OrderCard_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { OrderCard_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { OrderCard_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












const getDiscountPLus = (value, discount) => {
  return Number(Math.ceil(value - value * (discount / 100)).toFixed(2));
};

function OrderCard({
  product
}) {
  const {
    image,
    name,
    price,
    discountPrice,
    hasDiscount,
    discount,
    optionName,
    optionValue
  } = product;
  const currency = (0,hooks/* useSettingItem */.qT)('CURRENCY');
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PictureWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OrderCard_StyledPicture, OrderCard_objectSpread({}, (0,web_modules_esm/* convertThumbnailToPictureImage */.iS)(image)))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_DescriptionWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderCard_Name, {
        children: name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderCard_PriceWrapper, {
        children: price && discountPrice && !hasDiscount ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Price, {
            hasDiscount: true,
            children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Price, {
            children: [(0,common/* normalizePrice */.nQ)(discountPrice), " ", currency]
          })]
        }) : price && discountPrice && hasDiscount ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Price, {
            hasDiscount: true,
            children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Price, {
            children: [(0,common/* normalizePrice */.nQ)(discountPrice), " ", currency]
          })]
        }) : price && discount ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Price, {
            children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
          })
        }) : price && !discount ? /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderCard_Price, {
          children: [(0,common/* normalizePrice */.nQ)(price), " ", currency]
        }) : null
      })]
    }), optionName && /*#__PURE__*/(0,jsx_runtime.jsx)(OptionName, {
      children: optionName
    }), optionValue && /*#__PURE__*/(0,jsx_runtime.jsx)(OptionValue, {
      children: optionValue
    })]
  });
}

/* harmony default export */ var OrderCard_OrderCard = (OrderCard);
const OrderCard_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderCard__Component",
  componentId: "sc-1x4h6nn-0"
})(["border:1px solid ", ";margin:30px 0;padding:2px 15px;"], theme/* colors.gray100 */.O9.gray100);
const PictureWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderCard__PictureWrapper",
  componentId: "sc-1x4h6nn-1"
})(["padding:5px 0;"]);
const OrderCard_DescriptionWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderCard__DescriptionWrapper",
  componentId: "sc-1x4h6nn-2"
})(["margin-top:5px;"]);
const OrderCard_Name = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderCard__Name",
  componentId: "sc-1x4h6nn-3"
})(["font-style:normal;font-weight:500;font-size:14px;line-height:24px;"]);
const OrderCard_PriceWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderCard__PriceWrapper",
  componentId: "sc-1x4h6nn-4"
})(["max-width:460px;display:flex;align-items:center;& > div:not(:last-child){margin-right:15px;}"]);
const OrderCard_Price = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderCard__Price",
  componentId: "sc-1x4h6nn-5"
})(["", ""], ({
  hasDiscount,
  hasDiscountPLus
}) => hasDiscount && !hasDiscountPLus ? (0,styled_components_browser_esm.css)(["font-style:normal;line-height:20px;text-decoration-line:line-through;font-weight:500;font-size:14px;color:", ";"], theme/* colors.darkGrey */.O9.darkGrey) : hasDiscount && hasDiscountPLus ? (0,styled_components_browser_esm.css)(["font-style:normal;line-height:26px;font-weight:600;font-size:18px;text-decoration-line:line-through;color:", ";"], theme/* colors.black */.O9.black) : (0,styled_components_browser_esm.css)(["font-style:normal;line-height:26px;font-weight:600;font-size:22px;color:", ";"], theme/* colors.primary */.O9.primary));
const OptionName = styled_components_browser_esm["default"].span.withConfig({
  displayName: "OrderCard__OptionName",
  componentId: "sc-1x4h6nn-6"
})(["font-style:normal;font-weight:500;font-size:13px;line-height:20px;color:", ";"], theme/* colors.darkGrey */.O9.darkGrey);
const OptionValue = styled_components_browser_esm["default"].span.withConfig({
  displayName: "OrderCard__OptionValue",
  componentId: "sc-1x4h6nn-7"
})(["margin-left:20px;font-style:normal;font-weight:500;font-size:13px;line-height:20px;"]);
const OrderCard_StyledPicture = (0,styled_components_browser_esm["default"])(Picture/* default */.Z).withConfig({
  displayName: "OrderCard__StyledPicture",
  componentId: "sc-1x4h6nn-8"
})(["height:120px;width:100%;picture,img{height:100%;object-fit:contain;object-position:left;}"]);
;// CONCATENATED MODULE: ./src/components/OrderCard/index.ts

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/components/TextInput/index.ts + 6 modules
var TextInput = __webpack_require__(28560);
// EXTERNAL MODULE: ./src/components/TextInput/formikHelpers/form.helpers.ts
var form_helpers = __webpack_require__(75901);
// EXTERNAL MODULE: ./src/services/requests.ts
var requests = __webpack_require__(17146);
// EXTERNAL MODULE: ./src/components/Checkbox/index.ts + 3 modules
var Checkbox = __webpack_require__(17494);
;// CONCATENATED MODULE: ./src/components/Forms/OrderForm/OrderFormRequest.tsx

const OrderFormRequest_excluded = ["isSubmitting", "isValid", "values", "dirty"];
















const hasFrontendValidationErrors = (t, values) => !!Object.keys(validate(t, values)).length;

function validate(t, {
  phone,
  name
}) {
  const errors = {};

  if (!(0,form_helpers/* validatePhone */.a)(phone)) {
    errors.phone = t('forms.phone_error');
  }

  if (!phone) {
    errors.phone = t('forms.required');
  }

  if (!name) {
    errors.name = t('forms.required');
  }

  return errors;
}

function OrderFormRequest({
  setFormClosed,
  product
}) {
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();
  const t = (0,production/* useTranslations */.T_)();
  const agreementText = (0,hooks/* useSettingItem */.qT)('ORDER_FORM_AGREEMENT_TEXT');
  const {
    0: agreementChecked,
    1: setAgreementChecked
  } = (0,react.useState)(false);

  function handleSubmit(values, formikHelpers) {
    return (0,requests/* sendOrderForm */.aG)(values).then(() => {
      setFormClosed();
      closeModalState();
      formikHelpers.setSubmitting(true);
    }).catch(() => {
      formikHelpers.setErrors({
        phone: t('forms.unknown_error')
      });
      formikHelpers.setStatus({
        hasBackendError: true
      });
    }).finally(() => {
      formikHelpers.setSubmitting(false);
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(OrderFormRequest_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      initialValues: {
        productId: product === null || product === void 0 ? void 0 : product.id,
        option: product !== null && product !== void 0 && product.optionName ? (product === null || product === void 0 ? void 0 : product.optionName) + ': ' + (product === null || product === void 0 ? void 0 : product.optionValue) : '',
        name: '',
        phone: ''
      },
      onSubmit: handleSubmit,
      validate: fields => validate(t, fields),
      children: _ref => {
        let {
          isSubmitting,
          isValid,
          values,
          dirty
        } = _ref,
            props = (0,objectWithoutProperties/* default */.Z)(_ref, OrderFormRequest_excluded);

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          children: [product !== null && product !== void 0 && product.notInStock ? /*#__PURE__*/(0,jsx_runtime.jsx)(NotAvailable, {
            children: t('forms.no_item')
          }) : null, /*#__PURE__*/(0,jsx_runtime.jsx)(FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "name",
              icon: "profile",
              placeholder: t('forms.name'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "city",
              placeholder: t('forms.city'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "phone",
              icon: "phone",
              placeholder: t('forms.phone'),
              autoComplete: "off",
              invalid: false
            })
          }), (0,common/* getCurrentProject */.vo)() !== 'dveri' && /*#__PURE__*/(0,jsx_runtime.jsx)(AgreementRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Checkbox/* Checkbox */.X, {
              checked: agreementChecked,
              onChange: () => setAgreementChecked(!agreementChecked),
              label: agreementText || ''
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(SubmitRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* default */.C, {
              type: "submit",
              variant: "contained-primary-w100-f13",
              disabled: !agreementChecked || !(isValid || !hasFrontendValidationErrors(t, values)) && (0,form_helpers/* areAllErrorsVisible */.G)(props.errors, props.touched),
              children: t('forms.send'),
              loading: isSubmitting
            })
          })]
        });
      }
    })
  });
}

/* harmony default export */ var OrderForm_OrderFormRequest = (OrderFormRequest);
const OrderFormRequest_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderFormRequest__Component",
  componentId: "sc-dkhf14-0"
})(["padding-bottom:30px;"]);
const FormRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderFormRequest__FormRow",
  componentId: "sc-dkhf14-1"
})(["margin-bottom:20px;"]);
const OrderFormRequest_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderFormRequest__Text",
  componentId: "sc-dkhf14-2"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;margin-bottom:20px;"]);
const AgreementRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderFormRequest__AgreementRow",
  componentId: "sc-dkhf14-3"
})(["margin-top:20px;min-height:20px;"]);
const SubmitRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderFormRequest__SubmitRow",
  componentId: "sc-dkhf14-4"
})(["margin-top:20px;"]);
const NotAvailable = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderFormRequest__NotAvailable",
  componentId: "sc-dkhf14-5"
})(["background:", ";color:#fff;padding:10px 30px;font-size:12px;line-height:16px;text-align:center;margin-top:20px;font-weight:bold;margin-bottom:20px;"], theme/* colors.primary */.O9.primary);
;// CONCATENATED MODULE: ./src/components/Forms/OrderForm/OrderForm.tsx













function OrderForm({
  innerProps,
  closeModal
}) {
  const {
    0: isFormClosed,
    1: setFormClosed
  } = (0,react.useState)(false);
  const {
    title,
    orderData
  } = innerProps;
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderForm_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles_Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderForm_StyledCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderForm_Content, {
      children: isFormClosed ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessForm/* default */.Z, {
        title: t('forms.success_title'),
        text: t('forms.success_text')
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [orderData && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderCard_OrderCard, {
          product: orderData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(OrderForm_OrderFormRequest, {
          product: orderData,
          setFormClosed: () => setFormClosed(true)
        })]
      })
    })]
  });
}

/* harmony default export */ var OrderForm_OrderForm = (OrderForm);
const OrderForm_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderForm__Component",
  componentId: "sc-ltxygb-0"
})(["height:min(calc(var(--vh,1) * 100),80vh);min-width:min(100vw,500px);padding-bottom:15px;background:#fff;flex-shrink:1;-webkit-overflow-scrolling:touch !important;overflow:auto !important;position:relative;"]);
const OrderForm_StyledCloseButton = (0,styled_components_browser_esm["default"])(shared_CloseButton).withConfig({
  displayName: "OrderForm__StyledCloseButton",
  componentId: "sc-ltxygb-1"
})(["position:absolute;top:50%;transform:translateY(-50%);right:15px;"]);
const OrderForm_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "OrderForm__Content",
  componentId: "sc-ltxygb-2"
})(["height:100%;padding:0 15px;"]);
;// CONCATENATED MODULE: ./src/components/Forms/OrderForm/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Order/Order.tsx


function Order_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Order_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Order_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Order_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













function Order({
  product
}) {
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const activeIndex = (0,store/* useTypedSelector */.ix)(state => (0,product_product/* selectActiveId */.iJ)(state));
  const {
    price,
    discountPrice,
    optionData
  } = (0,react.useContext)(productContext);
  const discount = 2;
  const productData = (0,react.useMemo)(() => {
    var _product$name, _product$gallery$acti, _product$gallery$acti2;

    if (!product) {
      return null;
    }

    const id = product.id;
    const name = (_product$name = product === null || product === void 0 ? void 0 : product.name) !== null && _product$name !== void 0 ? _product$name : '';
    const image = !!(product !== null && product !== void 0 && product.gallery.length) ? (_product$gallery$acti = product.gallery[activeIndex]) === null || _product$gallery$acti === void 0 ? void 0 : (_product$gallery$acti2 = _product$gallery$acti.image) === null || _product$gallery$acti2 === void 0 ? void 0 : _product$gallery$acti2.preview : null;
    const productPrice = price;
    const productDiscountPrice = discountPrice;
    const optionName = product !== null && product !== void 0 && product.multiplePricesEnabled ? optionData === null || optionData === void 0 ? void 0 : optionData.optionName : null;
    const optionValue = product !== null && product !== void 0 && product.multiplePricesEnabled ? optionData === null || optionData === void 0 ? void 0 : optionData.optionValue : null;
    const hasDiscount = true;
    return {
      id,
      name,
      image,
      price: productPrice,
      discountPrice: productDiscountPrice,
      optionName,
      optionValue,
      hasDiscount,
      notInStock: product.availability === 'OUT_OF_ORDER'
    };
  }, [activeIndex, product, discountPrice, optionData === null || optionData === void 0 ? void 0 : optionData.optionName, optionData === null || optionData === void 0 ? void 0 : optionData.optionValue, price]);

  const handler = () => {
    openModal(OrderForm_OrderForm, {
      title: t('forms.leave_request'),
      orderData: productData && Order_objectSpread(Order_objectSpread({}, productData), {}, {
        discount
      })
    }, {
      withAnimation: false,
      scrollLockDisabled: true
    });
  };

  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Order_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledDiscountButton, {
      onClick: handler,
      discount: discount,
      children: t('product.buy_in_click')
    })
  });
}

/* harmony default export */ var Order_Order = (Order);
const Order_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Order__Component",
  componentId: "sc-95ol7r-0"
})(["margin-top:20px;padding:6px 15px 15px;background:", ";"], theme/* colors.grayBackground */.O9.grayBackground);
const DiscountText = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Order__DiscountText",
  componentId: "sc-95ol7r-1"
})(["text-align:center;font-style:normal;font-weight:normal;font-size:13px;line-height:24px;"]);
const StyledDiscountButton = (0,styled_components_browser_esm["default"])(Button_DiscountButton).withConfig({
  displayName: "Order__StyledDiscountButton",
  componentId: "sc-95ol7r-2"
})(["margin:6px auto 0;max-width:480px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Order/index.ts

;// CONCATENATED MODULE: ./src/components/Forms/CheaperForm/CheaperFormRequest.tsx

const CheaperFormRequest_excluded = ["isSubmitting", "isValid", "values", "dirty"];












const CheaperFormRequest_hasFrontendValidationErrors = (t, values) => !!Object.keys(CheaperFormRequest_validate(t, values)).length;

function CheaperFormRequest_validate(t, {
  phone,
  name,
  price,
  shop
}) {
  const errors = {};

  if (!(0,form_helpers/* validatePhone */.a)(phone)) {
    errors.phone = t('forms.phone_error');
  }

  if (!phone) {
    errors.phone = t('forms.required');
  }

  if (!name) {
    errors.name = t('forms.required');
  }

  if (!price) {
    errors.price = t('forms.required');
  }

  if (!shop) {
    errors.shop = t('forms.required');
  }

  return errors;
}

function CheaperFormRequest({
  setFormClosed,
  product
}) {
  const {
    closeModalState
  } = (0,useModalsOpen/* default */.Z)();
  const t = (0,production/* useTranslations */.T_)();

  function handleSubmit(values, formikHelpers) {
    return (0,requests/* sendCheaperForm */.$l)(values).then(() => {
      setFormClosed();
      closeModalState();
      formikHelpers.setSubmitting(true);
    }).catch(() => {
      formikHelpers.setErrors({
        phone: t('forms.unknown_error')
      });
      formikHelpers.setStatus({
        hasBackendError: true
      });
    }).finally(() => {
      formikHelpers.setSubmitting(false);
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperFormRequest_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
      initialValues: {
        productId: product === null || product === void 0 ? void 0 : product.id,
        option: product !== null && product !== void 0 && product.optionName ? (product === null || product === void 0 ? void 0 : product.optionName) + ': ' + (product === null || product === void 0 ? void 0 : product.optionValue) : '',
        name: '',
        phone: '',
        price: '',
        shop: ''
      },
      onSubmit: handleSubmit,
      validate: fields => CheaperFormRequest_validate(t, fields),
      children: _ref => {
        let {
          isSubmitting,
          isValid,
          values,
          dirty
        } = _ref,
            props = (0,objectWithoutProperties/* default */.Z)(_ref, CheaperFormRequest_excluded);

        return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CheaperFormRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "name",
              icon: "profile",
              placeholder: t('forms.name'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperFormRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "phone",
              icon: "phone",
              placeholder: t('forms.phone'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperFormRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "price",
              placeholder: t('forms.price_other'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperFormRequest_FormRow, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextInput/* TextInputFormik */.K, {
              name: "shop",
              placeholder: t('forms.shop'),
              autoComplete: "off",
              invalid: false
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperFormRequest_Text, {
            children: t('forms.check')
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Button/* default */.C, {
            type: "submit",
            variant: "contained-primary-w100-f13",
            disabled: !(isValid || !CheaperFormRequest_hasFrontendValidationErrors(t, values)) && (0,form_helpers/* areAllErrorsVisible */.G)(props.errors, props.touched),
            children: t('forms.send'),
            loading: isSubmitting
          })]
        });
      }
    })
  });
}

/* harmony default export */ var CheaperForm_CheaperFormRequest = (CheaperFormRequest);
const CheaperFormRequest_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CheaperFormRequest__Component",
  componentId: "sc-1jz5jmd-0"
})([""]);
const CheaperFormRequest_FormRow = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CheaperFormRequest__FormRow",
  componentId: "sc-1jz5jmd-1"
})(["margin-bottom:30px;"]);
const CheaperFormRequest_Text = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CheaperFormRequest__Text",
  componentId: "sc-1jz5jmd-2"
})(["font-style:normal;font-weight:normal;font-size:13px;line-height:20px;margin-bottom:20px;"]);
;// CONCATENATED MODULE: ./src/components/Forms/CheaperForm/CheaperForm.tsx













function CheaperForm({
  innerProps,
  closeModal
}) {
  const {
    0: isFormClosed,
    1: setFormClosed
  } = (0,react.useState)(false);
  const {
    title,
    orderData
  } = innerProps;
  (0,useBodyPositionFixed/* useBodyPositionFixed */.I)();
  const t = (0,production/* useTranslations */.T_)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(CheaperForm_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(styles_Header, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeaderTitle, {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperForm_StyledCloseButton, {
        onClick: closeModal
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperForm_Content, {
      children: isFormClosed ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessForm/* default */.Z, {
        title: t('forms.success_title'),
        text: t('forms.success_text')
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [orderData && /*#__PURE__*/(0,jsx_runtime.jsx)(OrderCard_OrderCard, {
          product: orderData
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CheaperForm_CheaperFormRequest, {
          product: orderData,
          setFormClosed: () => setFormClosed(true)
        })]
      })
    })]
  });
}

/* harmony default export */ var CheaperForm_CheaperForm = (CheaperForm);
const CheaperForm_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CheaperForm__Component",
  componentId: "sc-1jrcjs4-0"
})(["height:min(calc(var(--vh,1) * 100),80vh);min-width:min(100vw,500px);padding-bottom:15px;background:#fff;flex-shrink:1;-webkit-overflow-scrolling:touch !important;overflow:auto !important;position:relative;"]);
const CheaperForm_StyledCloseButton = (0,styled_components_browser_esm["default"])(shared_CloseButton).withConfig({
  displayName: "CheaperForm__StyledCloseButton",
  componentId: "sc-1jrcjs4-1"
})(["position:absolute;top:50%;transform:translateY(-50%);right:15px;"]);
const CheaperForm_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "CheaperForm__Content",
  componentId: "sc-1jrcjs4-2"
})(["height:100%;padding:0 15px;"]);
;// CONCATENATED MODULE: ./src/components/Forms/CheaperForm/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Cheaper/Cheaper.tsx


function Cheaper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Cheaper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Cheaper_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Cheaper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












const Cheaper = ({
  product
}) => {
  const openModal = (0,web_components_esm/* useModal */.dd)();
  const t = (0,production/* useTranslations */.T_)();
  const activeIndex = (0,store/* useTypedSelector */.ix)(state => (0,product_product/* selectActiveId */.iJ)(state));
  const {
    price,
    discountPrice,
    optionData
  } = (0,react.useContext)(productContext);
  const productData = (0,react.useMemo)(() => {
    var _product$name, _product$gallery$acti, _product$gallery$acti2;

    if (!product) {
      return null;
    }

    const id = product.id;
    const name = (_product$name = product === null || product === void 0 ? void 0 : product.name) !== null && _product$name !== void 0 ? _product$name : '';
    const image = !!(product !== null && product !== void 0 && product.gallery.length) ? (_product$gallery$acti = product.gallery[activeIndex]) === null || _product$gallery$acti === void 0 ? void 0 : (_product$gallery$acti2 = _product$gallery$acti.image) === null || _product$gallery$acti2 === void 0 ? void 0 : _product$gallery$acti2.preview : null;
    const productPrice = price;
    const productDiscountPrice = discountPrice;
    const optionName = product !== null && product !== void 0 && product.multiplePricesEnabled ? optionData === null || optionData === void 0 ? void 0 : optionData.optionName : null;
    const optionValue = product !== null && product !== void 0 && product.multiplePricesEnabled ? optionData === null || optionData === void 0 ? void 0 : optionData.optionValue : null;
    const hasDiscount = true;
    return {
      id,
      name,
      image,
      price: productPrice,
      discountPrice: productDiscountPrice,
      optionName,
      optionValue,
      hasDiscount
    };
  }, [activeIndex, product, discountPrice, optionData === null || optionData === void 0 ? void 0 : optionData.optionName, optionData === null || optionData === void 0 ? void 0 : optionData.optionValue, price]);

  const handler = () => {
    openModal(CheaperForm_CheaperForm, {
      title: t('forms.leave_request'),
      orderData: productData && Cheaper_objectSpread(Cheaper_objectSpread({}, productData), {}, {
        hasDiscount: false
      })
    }, {
      withAnimation: false,
      scrollLockDisabled: true
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Cheaper_Component, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(TextWithIcon_TextWithIcon, {
      icon: "wallet",
      note: t('forms.find_cheaper'),
      text: t('forms.write_us'),
      textButton: true,
      fontWeight: "normal",
      onClick: handler
    })
  });
};

/* harmony default export */ var Cheaper_Cheaper = (Cheaper);
const Cheaper_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Cheaper__Component",
  componentId: "sc-7n6pvu-0"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/components/Cheaper/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Main/Main.tsx























function Main_Main() {
  var _product$data, _product$data$waiting, _product$data2;

  const router = (0,next_router.useRouter)();
  const alias = (0,common/* getAliasString */.Jz)(router.query.alias);
  const product = (0,store/* useTypedSelector */.ix)(state => {
    return (0,product_product/* selectProductResource */.jN)(state, alias);
  });
  const t = (0,production/* useTranslations */.T_)();
  const availability = getOrderType((_product$data = product.data) === null || _product$data === void 0 ? void 0 : _product$data.availability, t);
  const waitingDays = (_product$data$waiting = (_product$data2 = product.data) === null || _product$data2 === void 0 ? void 0 : _product$data2.waitingDays) !== null && _product$data$waiting !== void 0 ? _product$data$waiting : 0;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Main_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderType, {
      children: [availability, " ", waitingDays > 0 ? waitingDays + ' ' + t('dimensions.days') : null]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Price_Price, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(MultiPrice_MultiPrice, {
      product: product.data
    }), (0,common/* getCurrentProject */.vo)() !== 'dveri' && /*#__PURE__*/(0,jsx_runtime.jsxs)(ContentContainer/* default */.Z, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
        to: BLOG_TISSUE_URL,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(TissueBotton, {
          children: t('product.tissue_more')
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Related_Related, {
        product: product.data
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Order_Order, {
      product: product.data
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TextWithIconWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TextWithIcon_TextWithIcon, {
        icon: "delivery",
        note: (0,common/* getCurrentProject */.vo)() === 'dveri' ? t('product.delivery_kiev') : t('product.delivery_minsk'),
        text: t('product.free'),
        hasColor: true,
        fontWeight: 600
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Cheaper_Cheaper, {
        product: product.data
      })]
    }), (0,common/* getCurrentProject */.vo)() !== 'dveri' && /*#__PURE__*/(0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Brand_Brand, {
        product: product.data
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Tabs_Tabs, {
      product: product.data
    })]
  });
}

/* harmony default export */ var components_Main_Main = (Main_Main);
const Main_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Main__Component",
  componentId: "sc-9td8zu-0"
})([""]);
const OrderType = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Main__OrderType",
  componentId: "sc-9td8zu-1"
})(["margin-top:20px;display:flex;align-items:center;justify-content:center;height:28px;font-style:normal;font-weight:600;font-size:13px;line-height:20px;background:", ";"], theme/* colors.grayBackground */.O9.grayBackground);
const TissueBotton = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Main__TissueBotton",
  componentId: "sc-9td8zu-2"
})(["margin-top:2px;cursor:pointer;display:inline-block;font-style:normal;font-weight:600;font-size:13px;line-height:20px;color:", ";"], theme/* colors.primary */.O9.primary);
const TextWithIconWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Main__TextWithIconWrapper",
  componentId: "sc-9td8zu-3"
})(["padding:11px 15px 13px;border-bottom:1px solid ", ";& > div:not(:first-child){margin-top:9px;}"], theme/* colors.gray70 */.O9.gray70);
;// CONCATENATED MODULE: ./src/modules/Product/components/Main/index.ts

// EXTERNAL MODULE: ./src/components/ProductCard/index.ts + 1 modules
var ProductCard = __webpack_require__(50819);
;// CONCATENATED MODULE: ./src/modules/Product/components/Footer/components/Relations/Relations.tsx


function Relations_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Relations_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Relations_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Relations_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

















core_class/* default.use */.Z.use([navigation/* default */.Z]);

function Relations({
  id
}) {
  const data = (0,store/* useTypedSelector */.ix)(state => {
    if (id) {
      return (0,product_product/* selectProductRelationListResource */.em)(state, id);
    }
  });
  const shouldCheckItemsAmount = (0,web_core_esm.useMedia)(`(min-width: 500px)`);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Relations_Component, {
    children: (data === null || data === void 0 ? void 0 : data.status) === web_core_esm.FETCH_STATUSES.SUCCESS ? data.data.map((content, index) => {
      return !!content.items.length ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Relations_Content, {
        className: "product-item-content",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Relations_Header, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Relations_Label, {
            children: content.name
          }), !shouldCheckItemsAmount && content.items.length > 1 || shouldCheckItemsAmount && content.items.length > 2 ? /*#__PURE__*/(0,jsx_runtime.jsxs)(Nav, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Prev, {
              className: 'prev-product-relation-item' + index
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Next, {
              className: 'next-product-relation-item' + index
            })]
          }) : null]
        }), !shouldCheckItemsAmount && content.items.length > 1 || shouldCheckItemsAmount && content.items.length > 2 ? /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
          navigation: {
            prevEl: '.prev-product-relation-item' + index,
            nextEl: '.next-product-relation-item' + index
          },
          slidesOffsetBefore: 15,
          slidesOffsetAfter: 15,
          spaceBetween: 15,
          slidesPerView: 1.25,
          slidesPerGroup: 1,
          breakpoints: {
            500: {
              slidesPerView: 2.2
            }
          },
          children: content.items.length === 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)(SingleCardWrapper, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
              to: '/products/' + content.items[0].urlAlias,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCard/* default */.Z, Relations_objectSpread({}, content.items[0]))
            })
          }) : content.items.map(item => {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
                to: '/products/' + item.urlAlias,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCard/* default */.Z, Relations_objectSpread({}, item))
              })
            }, item.id);
          })
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProductWrapper, {
          children: content.items.map((item, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
            to: '/products/' + item.urlAlias,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCard/* default */.Z, Relations_objectSpread({}, item))
          }))
        })]
      }, index) : null;
    }) : null
  });
}

/* harmony default export */ var Relations_Relations = (Relations);
const Relations_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Component",
  componentId: "sc-1kho022-0"
})(["& > .product-item-content:not(:first-child){margin-top:20px;}"]);
const Relations_Content = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Content",
  componentId: "sc-1kho022-1"
})([""]);
const Relations_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Label",
  componentId: "sc-1kho022-2"
})(["font-style:normal;font-weight:500;font-size:22px;line-height:40px;"]);
const Relations_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Header",
  componentId: "sc-1kho022-3"
})(["padding:0 15px;margin-bottom:5px;display:flex;align-items:center;justify-content:space-between;"]);
const Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Nav",
  componentId: "sc-1kho022-4"
})(["display:flex;justify-content:space-between;flex:0 0 46px;"]);
const Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Prev",
  componentId: "sc-1kho022-5"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__Next",
  componentId: "sc-1kho022-6"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const SingleCardWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__SingleCardWrapper",
  componentId: "sc-1kho022-7"
})(["padding:0 15px;max-width:480px;"]);
const ProductWrapper = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Relations__ProductWrapper",
  componentId: "sc-1kho022-8"
})(["padding:0 15px;display:grid;grid-template-columns:calc(50% - 7.5px) calc(50% - 7.5px);gap:15px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Footer/components/Relations/index.ts

// EXTERNAL MODULE: ./src/components/PlainPostCard/index.ts + 1 modules
var PlainPostCard = __webpack_require__(72578);
;// CONCATENATED MODULE: ./src/modules/Product/components/Footer/components/Blog/Blog.tsx


















core_class/* default.use */.Z.use([navigation/* default */.Z]);

function Blog({
  id
}) {
  const data = (0,store/* useTypedSelector */.ix)(state => {
    if (id) {
      return (0,product_product/* selectProductPostListResource */.$$)(state, id);
    }
  });
  const t = (0,production/* useTranslations */.T_)();
  if (!(data !== null && data !== void 0 && data.data) || !data.data.length) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Component, {
    children: (data === null || data === void 0 ? void 0 : data.status) === web_core_esm.FETCH_STATUSES.SUCCESS ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Blog_Header, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Label, {
          children: t('interesting')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Blog_Nav, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Prev, {
            className: 'prev-post-relation-item'
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Next, {
            className: 'next-post-relation-item'
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(swiper/* Swiper */.t, {
        navigation: {
          prevEl: '.prev-post-relation-item',
          nextEl: '.next-post-relation-item'
        },
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15,
        spaceBetween: 15,
        slidesPerView: 1.25,
        slidesPerGroup: 1,
        breakpoints: {
          500: {
            slidesPerView: 2.2
          }
        },
        children: !!data.data.length ? data.data.map((post, index) => /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_slide/* SwiperSlide */.o, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Link/* default */.Z, {
            to: '/blog/' + (post === null || post === void 0 ? void 0 : post.urlAlias),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlainPostCard/* default */.Z, {
              post: post
            })
          })
        }, index)) : null
      })]
    }) : null
  });
}

/* harmony default export */ var Blog_Blog = (Blog);
const Blog_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Component",
  componentId: "sc-1xz46o8-0"
})(["margin-top:20px;"]);
const Blog_Label = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Label",
  componentId: "sc-1xz46o8-1"
})(["font-style:normal;font-weight:500;font-size:22px;line-height:40px;"]);
const Blog_Header = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Header",
  componentId: "sc-1xz46o8-2"
})(["padding:0 15px;margin-bottom:5px;display:flex;align-items:center;justify-content:space-between;"]);
const Blog_Nav = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Nav",
  componentId: "sc-1xz46o8-3"
})(["display:flex;justify-content:space-between;flex:0 0 46px;"]);
const Blog_Prev = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Prev",
  componentId: "sc-1xz46o8-4"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{position:absolute;border-radius:5px 0 0 5px;content:'';top:0;right:0;height:1px;width:16px;transform-origin:100% 0;transform:rotate(315deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{position:absolute;border-radius:5px 0 0 5px;content:'';bottom:0;right:0;height:1px;width:15px;transform-origin:100% 0;transform:rotate(45deg);background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
const Blog_Next = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Blog__Next",
  componentId: "sc-1xz46o8-5"
})(["cursor:pointer;position:relative;height:22.5px;width:15px;&:before{cursor:pointer;position:absolute;content:'';top:0;left:0;height:1px;width:16px;transform-origin:0 0;transform:rotate(45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:after{cursor:pointer;position:absolute;content:'';bottom:0;left:0;height:1px;width:15px;transform-origin:0 0;transform:rotate(-45deg);border-radius:0 5px 5px 0;background-color:", ";transition:background-color 0.25s ease-in-out;}&:hover:before,&:hover:after{background-color:", ";}"], theme/* colors.black */.O9.black, theme/* colors.black */.O9.black, theme/* colors.black300 */.O9.black300);
;// CONCATENATED MODULE: ./src/modules/Product/components/Footer/components/Blog/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/components/Footer/Footer.tsx











function Footer_Footer() {
  const router = (0,next_router.useRouter)();
  const alias = (0,common/* getAliasString */.Jz)(router.query.alias);
  const {
    data
  } = (0,store/* useTypedSelector */.ix)(state => {
    return (0,product_product/* selectProductResource */.jN)(state, alias);
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Footer_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Relations_Relations, {
      id: data === null || data === void 0 ? void 0 : data.id
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Blog_Blog, {
      id: data === null || data === void 0 ? void 0 : data.id
    })]
  });
}

/* harmony default export */ var components_Footer_Footer = (Footer_Footer);
const Footer_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Footer__Component",
  componentId: "sc-16hq592-0"
})(["margin-top:18px;"]);
;// CONCATENATED MODULE: ./src/modules/Product/components/Footer/index.ts

;// CONCATENATED MODULE: ./src/modules/Product/Product.tsx










function Product() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Product_Component, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Header_Header, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Gallery_Gallery, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductContextProvider, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(components_Main_Main, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_Footer_Footer, {})]
  });
}

/* harmony default export */ var Product_Product = (Product);
const Product_Component = styled_components_browser_esm["default"].div.withConfig({
  displayName: "Product__Component",
  componentId: "sc-15qb3f2-0"
})([""]);
;// CONCATENATED MODULE: ./src/modules/Product/index.ts

;// CONCATENATED MODULE: ./src/pages/products/[alias].tsx


function _alias_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _alias_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { _alias_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { _alias_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }














function ProductPage(props) {
  var _props$product, _props$product2, _props$product3;

  const router = (0,next_router.useRouter)();
  const currentPath = (0,common/* getCurrentPath */.b$)(router);
  const canonicalUrl = "https://dverione.com.ua" + currentPath;

  if (props.pageType === 'NOT_FOUND') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_404["default"], {});
  }

  if (props.pageType === 'ERROR') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(_error["default"], _alias_objectSpread({}, (0,common/* convertErrorToProps */.g1)(props.error)));
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(web_components_esm/* Page */.T3, {
    title: (_props$product = props.product) === null || _props$product === void 0 ? void 0 : _props$product.pageTitle,
    description: (_props$product2 = props.product) === null || _props$product2 === void 0 ? void 0 : _props$product2.pageDescription,
    openGraphImage: (_props$product3 = props.product) === null || _props$product3 === void 0 ? void 0 : _props$product3.openGraphImage,
    canonicalUrl: canonicalUrl,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Product_Product, {})
    })
  });
}

ProductPage.getInitialProps = async ({
  store,
  query,
  res
}) => {
  const alias = (0,common/* getAliasString */.Jz)(query.alias);

  try {
    await Promise.all([...(0,thunks/* getSharedThunkList */.q)(store.dispatch), store.dispatch((0,product_product/* getProductByAliasThunk */.gH)(alias)).then(product => {
      if (product !== null && product !== void 0 && product.id) {
        return Promise.all([store.dispatch((0,product_product/* getProductPostListByIdThunk */.nO)(product.id)), store.dispatch((0,product_product/* getProductRelationListByIdThunk */.BW)(product.id))]);
      }
    })]);
    const productResource = (0,product_product/* selectProductResource */.jN)(store.getState(), alias);

    if (productResource.status === web_core_esm.FETCH_STATUSES.FAILURE) {
      if (res) {
        res.statusCode = 404;
      }

      return {
        pageType: 'NOT_FOUND'
      };
    }

    return {
      pageType: 'PRODUCT_PAGE',
      product: productResource.data
    };
  } catch (error) {
    return {
      pageType: 'ERROR',
      error
    };
  }
};

/* harmony default export */ var _alias_ = (ProductPage);

/***/ }),

/***/ 45072:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[alias]",
      function () {
        return __webpack_require__(53718);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [741,989,901,481,880,693,774,888,179], function() { return __webpack_exec__(45072); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);